// Generated by AvenyModelEditor

import { IRutinInfos, IRutinKeys, Leveransstatus } from '../../../../Types/RutinInfoType';

export const rutinInfos: IRutinInfos = {
  rtnSkotselFakt: {
    rutinID: 2,
    rutinKod: 'rtnSkotselFakt',
    rutinURL: 'FaktureraGravskotsel',
    benamning: 'Fakturera gravskötsel',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGravsatta: {
    rutinID: 3,
    rutinKod: 'rtnGravsatta',
    rutinURL: 'Gravsatta',
    benamning: 'Gravsatta',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArbetsunderlagSkapa: {
    rutinID: 4,
    rutinKod: 'rtnArbetsunderlagSkapa',
    rutinURL: 'SkapaArbetsunderlag',
    benamning: 'Skapa arbetsunderlag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArbetsunderlag: {
    rutinID: 5,
    rutinKod: 'rtnArbetsunderlag',
    rutinURL: 'Arbetsunderlag',
    benamning: 'Arbetsunderlag',
    leveransstatus: Leveransstatus.Alfa,
  },
  optKGardar: {
    rutinID: 7,
    rutinKod: 'optKGardar',
    rutinURL: 'Kyrkogardar',
    benamning: 'Kyrkogårdar',
    leveransstatus: Leveransstatus.Alfa,
  },
  optStyrvarden: {
    rutinID: 8,
    rutinKod: 'optStyrvarden',
    rutinURL: 'OvrigaStyrvardenGrav',
    benamning: 'Övriga styrvärden Grav',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGravSkotAdm: {
    rutinID: 9,
    rutinKod: 'rtnGravSkotAdm',
    rutinURL: 'KrediteraErbjudande',
    benamning: 'Kreditera erbjudande',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKontakter: {
    rutinID: 10,
    rutinKod: 'rtnKontakter',
    rutinURL: 'Kontakter',
    benamning: 'Kontakter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFasttidsavtAvr: {
    rutinID: 12,
    rutinKod: 'rtnFasttidsavtAvr',
    rutinURL: 'AvraknaFasttidsavtal',
    benamning: 'Avräkna fasttidsavtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  optSkotsellistor: {
    rutinID: 13,
    rutinKod: 'optSkotsellistor',
    rutinURL: 'Skotselstatistik',
    benamning: 'Skötselstatistik',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSkotselExport: {
    rutinID: 14,
    rutinKod: 'rtnSkotselExport',
    rutinURL: 'Skotsel',
    benamning: 'Skötsel',
    leveransstatus: Leveransstatus.Alfa,
  },
  optGravlistor: {
    rutinID: 15,
    rutinKod: 'optGravlistor',
    rutinURL: 'Gravstatistik',
    benamning: 'Gravstatistik',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGamlaAvtal: {
    rutinID: 16,
    rutinKod: 'rtnGamlaAvtal',
    rutinURL: 'EjSkuldfordaAvtal',
    benamning: 'Ej skuldförda avtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOrderOmg: {
    rutinID: 17,
    rutinKod: 'rtnOrderOmg',
    rutinURL: 'Orderomgangar',
    benamning: 'Orderomgångar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAvrakningsavtAvr: {
    rutinID: 19,
    rutinKod: 'rtnAvrakningsavtAvr',
    rutinURL: 'AvraknaAvrakningsavtal',
    benamning: 'Avräkna avräkningsavtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGravarBytKontakt: {
    rutinID: 20,
    rutinKod: 'rtnGravarBytKontakt',
    rutinURL: '_',
    benamning: '',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFasttidsavtalUppr: {
    rutinID: 22,
    rutinKod: 'rtnFasttidsavtalUppr',
    rutinURL: 'UppraknaFasttidsavtal',
    benamning: 'Uppräkna fasttidsavtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAvrakningsavtKalk: {
    rutinID: 23,
    rutinKod: 'rtnAvrakningsavtKalk',
    rutinURL: 'GarantiatagandeAvrakningsavtal',
    benamning: 'Garantiåtagande avräkningsavtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGravanalys: {
    rutinID: 24,
    rutinKod: 'rtnGravanalys',
    rutinURL: 'AnalysAvAvenyGrav',
    benamning: 'Analys av Aveny Grav',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBestallningsOrder: {
    rutinID: 25,
    rutinKod: 'rtnBestallningsOrder',
    rutinURL: 'SkapaBestallningsorder',
    benamning: 'Skapa beställningsorder',
    leveransstatus: Leveransstatus.Alfa,
  },
  optMallar: {
    rutinID: 26,
    rutinKod: 'optMallar',
    rutinURL: 'Mallar',
    benamning: 'Mallar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRensaBetansv: {
    rutinID: 27,
    rutinKod: 'rtnRensaBetansv',
    rutinURL: 'RensaAvtal',
    benamning: 'Rensa avtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRensaESAvtal: {
    rutinID: 28,
    rutinKod: 'rtnRensaESAvtal',
    rutinURL: 'RensaEjSkuldfFasttidsavtal',
    benamning: 'Rensa ej skuldf fasttidsavtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPubliceraGravsatta: {
    rutinID: 29,
    rutinKod: 'rtnPubliceraGravsatta',
    rutinURL: 'PubliceraTillSvenskaGravar',
    benamning: 'Publicera till Svenska Gravar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSkotslar: {
    rutinID: 30,
    rutinKod: 'rtnSkotslar',
    rutinURL: 'Skotsel_2',
    benamning: 'Skötsel',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGravKartaTeman: {
    rutinID: 31,
    rutinKod: 'rtnGravKartaTeman',
    rutinURL: 'GravplatstemanAvenyKarta',
    benamning: 'Gravplatsteman Aveny Karta',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEjSkuldfAvtal: {
    rutinID: 32,
    rutinKod: 'rtnEjSkuldfAvtal',
    rutinURL: 'EjSkuldfordaAvtal_2',
    benamning: 'Ej skuldförda avtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSkotslar2: {
    rutinID: 33,
    rutinKod: 'rtnSkotslar2',
    rutinURL: 'Skotsel_3',
    benamning: 'Skötsel',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSkotslar3: {
    rutinID: 34,
    rutinKod: 'rtnSkotslar3',
    rutinURL: 'Skotsel_4',
    benamning: 'Skötsel',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGravHandelseLogg: {
    rutinID: 35,
    rutinKod: 'rtnGravHandelseLogg',
    rutinURL: 'Handelser',
    benamning: 'Händelser',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnInformationskiosk: {
    rutinID: 36,
    rutinKod: 'rtnInformationskiosk',
    rutinURL: 'Informationskiosk',
    benamning: 'Informationskiosk',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGravarNollaSaldo: {
    rutinID: 37,
    rutinKod: 'rtnGravarNollaSaldo',
    rutinURL: 'JusteraSaldoPaAvtal',
    benamning: 'Justera saldo på avtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAvtalFakt: {
    rutinID: 38,
    rutinKod: 'rtnAvtalFakt',
    rutinURL: 'FaktureraGravskotselavtal',
    benamning: 'Fakturera gravskötselavtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUtgaendeSkotsel: {
    rutinID: 39,
    rutinKod: 'rtnUtgaendeSkotsel',
    rutinURL: 'HanteraUtgaendeAvtal',
    benamning: 'Hantera utgående avtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnExporteraPersonFraga: {
    rutinID: 40,
    rutinKod: 'rtnExporteraPersonFraga',
    rutinURL: 'ExporteraImporteraPersonfragaPaFilNavet',
    benamning: 'Exportera/importera personfråga på fil (Navet)',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSkotselKategorier: {
    rutinID: 41,
    rutinKod: 'rtnSkotselKategorier',
    rutinURL: 'Bestallningskategorier',
    benamning: 'Beställningskategorier',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSkotselBestallningar: {
    rutinID: 42,
    rutinKod: 'rtnSkotselBestallningar',
    rutinURL: 'Skotselbestallningar',
    benamning: 'Skötselbeställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGravMyCartaUrval: {
    rutinID: 43,
    rutinKod: 'rtnGravMyCartaUrval',
    rutinURL: 'TemanAvenyMyCarta',
    benamning: 'Teman Aveny MyCarta',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGravanordningar: {
    rutinID: 44,
    rutinKod: 'rtnGravanordningar',
    rutinURL: 'Gravanordningar',
    benamning: 'Gravanordningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPubliceradeKartor: {
    rutinID: 45,
    rutinKod: 'rtnPubliceradeKartor',
    rutinURL: 'MyCartaWeb',
    benamning: 'MyCarta Web',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSvenskaGravar: {
    rutinID: 46,
    rutinKod: 'rtnSvenskaGravar',
    rutinURL: 'SvenskaGravar',
    benamning: 'Svenska Gravar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSekretessGrav: {
    rutinID: 47,
    rutinKod: 'rtnSekretessGrav',
    rutinURL: 'SekretessbehorighetGrav',
    benamning: 'Sekretessbehörighet Grav',
    leveransstatus: Leveransstatus.Active,
  },
  optHandelseinstallningar: {
    rutinID: 48,
    rutinKod: 'optHandelseinstallningar',
    rutinURL: 'Handelseinstallningar',
    benamning: 'Händelseinställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUsersGA: {
    rutinID: 49,
    rutinKod: 'rtnUsersGA',
    rutinURL: 'AnvandareGravinstallningar',
    benamning: 'Användare, gravinställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUtseGravrattsinnehavare: {
    rutinID: 50,
    rutinKod: 'rtnUtseGravrattsinnehavare',
    rutinURL: 'UtseGravrattsinnehavare',
    benamning: 'Utse gravrättsinnehavare',
    leveransstatus: Leveransstatus.Alfa,
  },
  optGravrattsinnehavareInstallningar: {
    rutinID: 51,
    rutinKod: 'optGravrattsinnehavareInstallningar',
    rutinURL: 'UtseGravrattsinnehavareInstallningar',
    benamning: 'Utse gravrättsinnehavare inställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  optVanvardsarendenInstallningar: {
    rutinID: 52,
    rutinKod: 'optVanvardsarendenInstallningar',
    rutinURL: 'HanteraVanvardInstallningar',
    benamning: 'Hantera vanvård inställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVanvardsarenden: {
    rutinID: 53,
    rutinKod: 'rtnVanvardsarenden',
    rutinURL: 'HanteraVanvard',
    benamning: 'Hantera vanvård',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAktiviteter: {
    rutinID: 1001,
    rutinKod: 'rtnAktiviteter',
    rutinURL: 'Aktiviteter',
    benamning: 'Aktiviteter',
    leveransstatus: Leveransstatus.Active,
  },
  rtnResurser: {
    rutinID: 1003,
    rutinKod: 'rtnResurser',
    rutinURL: 'Resurser',
    benamning: 'Resurser',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGudstjansttyp: {
    rutinID: 1005,
    rutinKod: 'rtnGudstjansttyp',
    rutinURL: 'Gudstjansttyper',
    benamning: 'Gudstjänsttyper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDeltagarlista: {
    rutinID: 1006,
    rutinKod: 'rtnDeltagarlista',
    rutinURL: 'Deltagarlista',
    benamning: 'Deltagarlista',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBONummerserier: {
    rutinID: 1007,
    rutinKod: 'rtnBONummerserier',
    rutinURL: 'NummerserieBokning',
    benamning: 'Nummerserie (bokning)',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAktTypInstallningar: {
    rutinID: 1008,
    rutinKod: 'rtnAktTypInstallningar',
    rutinURL: 'Aktivitetstyper',
    benamning: 'Aktivitetstyper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDeltagare: {
    rutinID: 1009,
    rutinKod: 'rtnDeltagare',
    rutinURL: 'Deltagare',
    benamning: 'Deltagare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnResursRubriker: {
    rutinID: 1010,
    rutinKod: 'rtnResursRubriker',
    rutinURL: 'Resursrubrik',
    benamning: 'Resursrubrik',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturaOmgang: {
    rutinID: 1011,
    rutinKod: 'rtnFakturaOmgang',
    rutinURL: 'Fakturaunderlag',
    benamning: 'Fakturaunderlag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOPGrupp: {
    rutinID: 1012,
    rutinKod: 'rtnOPGrupp',
    rutinURL: 'GruppAvPersoner',
    benamning: 'Grupp av personer',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBegrByra: {
    rutinID: 1013,
    rutinKod: 'rtnBegrByra',
    rutinURL: 'Begravningsbyraer',
    benamning: 'Begravningsbyråer',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVerksamhetstyper: {
    rutinID: 1016,
    rutinKod: 'rtnVerksamhetstyper',
    rutinURL: 'Verksamhetstyper',
    benamning: 'Verksamhetstyper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSammankomst: {
    rutinID: 1017,
    rutinKod: 'rtnSammankomst',
    rutinURL: 'Sammankomster',
    benamning: 'Sammankomster',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBegravningstyp: {
    rutinID: 1018,
    rutinKod: 'rtnBegravningstyp',
    rutinURL: 'Begravningsordning',
    benamning: 'Begravningsordning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAktivitetskategori: {
    rutinID: 1019,
    rutinKod: 'rtnAktivitetskategori',
    rutinURL: 'FramsidanKategorier',
    benamning: 'Framsidan - kategorier',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAnnonseras: {
    rutinID: 1020,
    rutinKod: 'rtnAnnonseras',
    rutinURL: 'Annonseras',
    benamning: 'Annonseras',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGruppmedlemmar: {
    rutinID: 1021,
    rutinKod: 'rtnGruppmedlemmar',
    rutinURL: 'Utskick',
    benamning: 'Utskick',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAnmalningar: {
    rutinID: 1022,
    rutinKod: 'rtnAnmalningar',
    rutinURL: 'Anmalningar',
    benamning: 'Anmälningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBestallningar: {
    rutinID: 1023,
    rutinKod: 'rtnBestallningar',
    rutinURL: 'Bokningsbestallningar',
    benamning: 'Bokningsbeställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUsersBO: {
    rutinID: 1025,
    rutinKod: 'rtnUsersBO',
    rutinURL: 'AnvandareBokningsinstallningar',
    benamning: 'Användare, bokningsinställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnResurstyper: {
    rutinID: 1026,
    rutinKod: 'rtnResurstyper',
    rutinURL: 'Resurstyper',
    benamning: 'Resurstyper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBokningar: {
    rutinID: 1029,
    rutinKod: 'rtnBokningar',
    rutinURL: 'Bokningar',
    benamning: 'Bokningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAktdeltagare: {
    rutinID: 1030,
    rutinKod: 'rtnAktdeltagare',
    rutinURL: 'Deltagare_2',
    benamning: 'Deltagare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAktkontakt: {
    rutinID: 1031,
    rutinKod: 'rtnAktkontakt',
    rutinURL: 'Kursdeltagare',
    benamning: 'Kursdeltagare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTjanstgoring: {
    rutinID: 1032,
    rutinKod: 'rtnTjanstgoring',
    rutinURL: 'Tjanstgoring',
    benamning: 'Tjänstgöring',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPlaneringskategorier: {
    rutinID: 1033,
    rutinKod: 'rtnPlaneringskategorier',
    rutinURL: 'Planeringskategorier',
    benamning: 'Planeringskategorier',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnResursgrupp: {
    rutinID: 1034,
    rutinKod: 'rtnResursgrupp',
    rutinURL: 'Resursgrupper',
    benamning: 'Resursgrupper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBoknBest: {
    rutinID: 1035,
    rutinKod: 'rtnBoknBest',
    rutinURL: 'Bokningsbestallningar_2',
    benamning: 'Bokningsbeställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  optBoknBestSettings: {
    rutinID: 1036,
    rutinKod: 'optBoknBestSettings',
    rutinURL: 'StyrvardenBokningsbestallningar',
    benamning: 'Styrvärden Bokningsbeställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArsbaseradStatistik: {
    rutinID: 1037,
    rutinKod: 'rtnArsbaseradStatistik',
    rutinURL: 'ArsbaseradStatistikrapportering',
    benamning: 'Årsbaserad statistikrapportering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnStatistikrapporteringNew: {
    rutinID: 1038,
    rutinKod: 'rtnStatistikrapporteringNew',
    rutinURL: 'Statistikrapportering',
    benamning: 'Statistikrapportering',
    leveransstatus: Leveransstatus.Active,
  },
  rtnSekretessBokning: {
    rutinID: 1039,
    rutinKod: 'rtnSekretessBokning',
    rutinURL: 'SekretessbehorighetBokning',
    benamning: 'Sekretessbehörighet Bokning',
    leveransstatus: Leveransstatus.Active,
  },
  optPsalmer: {
    rutinID: 1040,
    rutinKod: 'optPsalmer',
    rutinURL: 'Psalmer',
    benamning: 'Psalmer',
    leveransstatus: Leveransstatus.Active,
  },
  rtnKonteringsmall: {
    rutinID: 2001,
    rutinKod: 'rtnKonteringsmall',
    rutinURL: 'Konteringsmall',
    benamning: 'Konteringsmall',
    leveransstatus: Leveransstatus.Alfa,
  },
  optKontoplan: {
    rutinID: 2002,
    rutinKod: 'optKontoplan',
    rutinURL: 'Kodplan',
    benamning: 'Kodplan',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKontodel: {
    rutinID: 2003,
    rutinKod: 'rtnKontodel',
    rutinURL: 'Koddel',
    benamning: 'Koddel',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVerifikation: {
    rutinID: 2004,
    rutinKod: 'rtnVerifikation',
    rutinURL: 'Verifikationsregistrering',
    benamning: 'Verifikationsregistrering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnIngBalans: {
    rutinID: 2005,
    rutinKod: 'rtnIngBalans',
    rutinURL: 'IngaendeBalans',
    benamning: 'Ingående balans',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBudgetVerifikation: {
    rutinID: 2006,
    rutinKod: 'rtnBudgetVerifikation',
    rutinURL: 'Budget',
    benamning: 'Budget',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKontoAnalys: {
    rutinID: 2007,
    rutinKod: 'rtnKontoAnalys',
    rutinURL: 'Kontoanalys',
    benamning: 'Kontoanalys',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEkonomiRapporter: {
    rutinID: 2008,
    rutinKod: 'rtnEkonomiRapporter',
    rutinURL: 'Ekonomirapporter',
    benamning: 'Ekonomirapporter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAutomatkontering: {
    rutinID: 2009,
    rutinKod: 'rtnAutomatkontering',
    rutinURL: 'Automatkontering',
    benamning: 'Automatkontering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSpecEkoRapport: {
    rutinID: 2010,
    rutinKod: 'rtnSpecEkoRapport',
    rutinURL: 'Rapportdefinitioner',
    benamning: 'Rapportdefinitioner',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEKRapportmall: {
    rutinID: 2011,
    rutinKod: 'rtnEKRapportmall',
    rutinURL: 'Rapportmall',
    benamning: 'Rapportmall',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEKLonefil: {
    rutinID: 2012,
    rutinKod: 'rtnEKLonefil',
    rutinURL: 'InlasningAvLoneverifikationer',
    benamning: 'Inläsning av löneverifikationer',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEKImporteraBudget: {
    rutinID: 2013,
    rutinKod: 'rtnEKImporteraBudget',
    rutinURL: 'ImporteraBudget',
    benamning: 'Importera budget',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBudgetKurva: {
    rutinID: 2014,
    rutinKod: 'rtnBudgetKurva',
    rutinURL: 'Budgetkurva',
    benamning: 'Budgetkurva',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEKRapporthuvud: {
    rutinID: 2015,
    rutinKod: 'rtnEKRapporthuvud',
    rutinURL: 'Sidhuvud',
    benamning: 'Sidhuvud',
    leveransstatus: Leveransstatus.Alfa,
  },
  optMomskod: {
    rutinID: 2016,
    rutinKod: 'optMomskod',
    rutinURL: 'Momskod',
    benamning: 'Momskod',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUpdateIBWizard: {
    rutinID: 2017,
    rutinKod: 'rtnUpdateIBWizard',
    rutinURL: 'UppdateraIngaendeBalans',
    benamning: 'Uppdatera ingående balans',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnValjKonteringsbegrepp: {
    rutinID: 2018,
    rutinKod: 'rtnValjKonteringsbegrepp',
    rutinURL: 'ValjKonteringsbegrepp',
    benamning: 'Välj konteringsbegrepp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDetaljeringsniva: {
    rutinID: 2019,
    rutinKod: 'rtnDetaljeringsniva',
    rutinURL: 'SummeringsreceptForEkonomirapporter',
    benamning: 'Summeringsrecept för ekonomirapporter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEKRapportkategori: {
    rutinID: 2021,
    rutinKod: 'rtnEKRapportkategori',
    rutinURL: 'Rapportkategori',
    benamning: 'Rapportkategori',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEKRapportpaket: {
    rutinID: 2022,
    rutinKod: 'rtnEKRapportpaket',
    rutinURL: 'Rapportpaket',
    benamning: 'Rapportpaket',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSIEExport: {
    rutinID: 2024,
    rutinKod: 'rtnSIEExport',
    rutinURL: 'ExportEnligtSIE',
    benamning: 'Export enligt SIE',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKopieraBudget: {
    rutinID: 2025,
    rutinKod: 'rtnKopieraBudget',
    rutinURL: 'KopieraForegaendeArsBudget',
    benamning: 'Kopiera föregående års budget',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKonteringar: {
    rutinID: 2026,
    rutinKod: 'rtnKonteringar',
    rutinURL: 'Verifikationsrader',
    benamning: 'Verifikationsrader',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLikviditetsplan: {
    rutinID: 2027,
    rutinKod: 'rtnLikviditetsplan',
    rutinURL: 'Likviditetsplan',
    benamning: 'Likviditetsplan',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSIEImport: {
    rutinID: 2028,
    rutinKod: 'rtnSIEImport',
    rutinURL: 'ImportEnligtSIE',
    benamning: 'Import enligt SIE',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOmfordelning: {
    rutinID: 2029,
    rutinKod: 'rtnOmfordelning',
    rutinURL: 'Omfordelning',
    benamning: 'Omfördelning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGavogrupp: {
    rutinID: 2030,
    rutinKod: 'rtnGavogrupp',
    rutinURL: 'Gavogrupp',
    benamning: 'Gåvogrupp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGava: {
    rutinID: 2031,
    rutinKod: 'rtnGava',
    rutinURL: 'Gavoregister',
    benamning: 'Gåvoregister',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGavorad: {
    rutinID: 2032,
    rutinKod: 'rtnGavorad',
    rutinURL: 'Gavorader',
    benamning: 'Gåvorader',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGavorubrik: {
    rutinID: 2033,
    rutinKod: 'rtnGavorubrik',
    rutinURL: 'Gavorubrik',
    benamning: 'Gåvorubrik',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLoneanalys: {
    rutinID: 2034,
    rutinKod: 'rtnLoneanalys',
    rutinURL: 'LonetransaktionerHogiaKyrklon',
    benamning: 'Lönetransaktioner Hogia Kyrklön',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVerunderlag: {
    rutinID: 2035,
    rutinKod: 'rtnVerunderlag',
    rutinURL: 'UtskriftAvVerifikationForUnderskrift',
    benamning: 'Utskrift av verifikation för underskrift',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUsersEK: {
    rutinID: 2036,
    rutinKod: 'rtnUsersEK',
    rutinURL: 'AnvandareEkonomiinstallningar',
    benamning: 'Användare, ekonomiinställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturahandelser: {
    rutinID: 2037,
    rutinKod: 'rtnFakturahandelser',
    rutinURL: 'Fakturahandelser',
    benamning: 'Fakturahändelser',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBudgetgrupp: {
    rutinID: 2038,
    rutinKod: 'rtnBudgetgrupp',
    rutinURL: 'Budgetgrupp',
    benamning: 'Budgetgrupp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLonetillagg: {
    rutinID: 2039,
    rutinKod: 'rtnLonetillagg',
    rutinURL: 'SarskildaErsattningar',
    benamning: 'Särskilda ersättningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPersonalgrupp: {
    rutinID: 2040,
    rutinKod: 'rtnPersonalgrupp',
    rutinURL: 'Personalgrupp',
    benamning: 'Personalgrupp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBefattningskod: {
    rutinID: 2041,
    rutinKod: 'rtnBefattningskod',
    rutinURL: 'Befattningskod',
    benamning: 'Befattningskod',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAvtalsomrade: {
    rutinID: 2042,
    rutinKod: 'rtnAvtalsomrade',
    rutinURL: 'Avtalsomrade',
    benamning: 'Avtalsområde',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPersonalregister: {
    rutinID: 2043,
    rutinKod: 'rtnPersonalregister',
    rutinURL: 'Personalregister',
    benamning: 'Personalregister',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPalagg: {
    rutinID: 2044,
    rutinKod: 'rtnPalagg',
    rutinURL: 'AvtalsenligaSocialaAvgifter',
    benamning: 'Avtalsenliga sociala avgifter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBudgetkategori: {
    rutinID: 2045,
    rutinKod: 'rtnBudgetkategori',
    rutinURL: 'Budgetkategori',
    benamning: 'Budgetkategori',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArbetsbudget: {
    rutinID: 2046,
    rutinKod: 'rtnArbetsbudget',
    rutinURL: 'Arbetsbudget',
    benamning: 'Arbetsbudget',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArbetsbudgetBudgetgrupp: {
    rutinID: 2047,
    rutinKod: 'rtnArbetsbudgetBudgetgrupp',
    rutinURL: 'ArbetsbudgetBudgetgrupp',
    benamning: 'Arbetsbudget - budgetgrupp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArbetsbudgetPersonalregister: {
    rutinID: 2048,
    rutinKod: 'rtnArbetsbudgetPersonalregister',
    rutinURL: 'ArbetsbudgetPersonalregister',
    benamning: 'Arbetsbudget - personalregister',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBudgeteringsmodell: {
    rutinID: 2049,
    rutinKod: 'rtnBudgeteringsmodell',
    rutinURL: 'SummeringsmodellForBudget',
    benamning: 'Summeringsmodell för budget',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArbetsbudgetrad: {
    rutinID: 2050,
    rutinKod: 'rtnArbetsbudgetrad',
    rutinURL: 'ArbetsbudgetBudgetrader',
    benamning: 'Arbetsbudget - budgetrader',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBudgetrutinInstallningar: {
    rutinID: 2051,
    rutinKod: 'rtnBudgetrutinInstallningar',
    rutinURL: 'ArbetsbudgetInstallningar',
    benamning: 'Arbetsbudget – inställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArbetsbudgetPersonalbudgetrader: {
    rutinID: 2052,
    rutinKod: 'rtnArbetsbudgetPersonalbudgetrader',
    rutinURL: 'ArbetsbudgetPersonalbudgetrader',
    benamning: 'Arbetsbudget – personalbudgetrader',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEKSettings: {
    rutinID: 2053,
    rutinKod: 'rtnEKSettings',
    rutinURL: 'SysteminstallningarEkonomi',
    benamning: 'Systeminställningar, Ekonomi',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKodbehorigheter: {
    rutinID: 2054,
    rutinKod: 'rtnKodbehorigheter',
    rutinURL: 'UtdeladeKodbehorigheter',
    benamning: 'Utdelade kodbehörigheter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBokforingsmall: {
    rutinID: 2055,
    rutinKod: 'rtnBokforingsmall',
    rutinURL: 'Bokforingsmall',
    benamning: 'Bokföringsmall',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEKLoneart: {
    rutinID: 2057,
    rutinKod: 'rtnEKLoneart',
    rutinURL: 'Loneart',
    benamning: 'Löneart',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTillaggsinfo: {
    rutinID: 2058,
    rutinKod: 'rtnTillaggsinfo',
    rutinURL: 'Tillaggsinformation',
    benamning: 'Tilläggsinformation',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEKLonefilIntern: {
    rutinID: 2059,
    rutinKod: 'rtnEKLonefilIntern',
    rutinURL: 'InlasningAvInternfordelningFranLon',
    benamning: 'Inläsning av internfördelning från Lön',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEkonomiskAnalys: {
    rutinID: 2060,
    rutinKod: 'rtnEkonomiskAnalys',
    rutinURL: 'EkonomiskAnalys',
    benamning: 'Ekonomisk Analys',
    leveransstatus: Leveransstatus.Active,
  },
  rtnAnalysutdelning: {
    rutinID: 2061,
    rutinKod: 'rtnAnalysutdelning',
    rutinURL: 'UtdelningAvEkonomiskAnalys',
    benamning: 'Utdelning av ekonomisk analys',
    leveransstatus: Leveransstatus.Active,
  },
  rtnKOBTransTyper: {
    rutinID: 2062,
    rutinKod: 'rtnKOBTransTyper',
    rutinURL: 'KOBTransaktionstyper',
    benamning: 'KOB Transaktionstyper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKOBAterredovisning: {
    rutinID: 2063,
    rutinKod: 'rtnKOBAterredovisning',
    rutinURL: 'BokforingsfilFranKOB',
    benamning: 'Bokföringsfil från KOB',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnMomsunderlag: {
    rutinID: 2065,
    rutinKod: 'rtnMomsunderlag',
    rutinURL: 'Momsunderlag',
    benamning: 'Momsunderlag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKOBKollektstyrning: {
    rutinID: 2068,
    rutinKod: 'rtnKOBKollektstyrning',
    rutinURL: 'KOBKollektstyrning',
    benamning: 'KOB Kollektstyrning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnMallarForUtlandskMoms: {
    rutinID: 2069,
    rutinKod: 'rtnMallarForUtlandskMoms',
    rutinURL: 'MallarForUtlandskMoms',
    benamning: 'Mallar för utländsk moms',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTillgang: {
    rutinID: 3001,
    rutinKod: 'rtnTillgang',
    rutinURL: 'AnlaggningarInventarier',
    benamning: 'Anläggningar/Inventarier',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRubrik: {
    rutinID: 3002,
    rutinKod: 'rtnRubrik',
    rutinURL: 'Rubrik',
    benamning: 'Rubrik',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnByggnaderRum: {
    rutinID: 3003,
    rutinKod: 'rtnByggnaderRum',
    rutinURL: 'ByggnaderOchRum',
    benamning: 'Byggnader och rum',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAnlKat: {
    rutinID: 3004,
    rutinKod: 'rtnAnlKat',
    rutinURL: 'Anlaggningskategori',
    benamning: 'Anläggningskategori',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAnlGrupp: {
    rutinID: 3005,
    rutinKod: 'rtnAnlGrupp',
    rutinURL: 'Anlaggningsgrupp',
    benamning: 'Anläggningsgrupp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOmrade: {
    rutinID: 3006,
    rutinKod: 'rtnOmrade',
    rutinURL: 'OmradePlats',
    benamning: 'Område (plats)',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnInvestRader: {
    rutinID: 3007,
    rutinKod: 'rtnInvestRader',
    rutinURL: 'Investeringsrader',
    benamning: 'Investeringsrader',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAutoAvskr: {
    rutinID: 3008,
    rutinKod: 'rtnAutoAvskr',
    rutinURL: 'BokforAvskrivningar',
    benamning: 'Bokför avskrivningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAutoInternranta: {
    rutinID: 3009,
    rutinKod: 'rtnAutoInternranta',
    rutinURL: 'BokforInternranta',
    benamning: 'Bokför internränta',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnMakuleraInvrad: {
    rutinID: 3010,
    rutinKod: 'rtnMakuleraInvrad',
    rutinURL: 'MakuleraAktiveringKostnForing',
    benamning: 'Makulera aktivering/kostn.föring',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnHuvudRubrik: {
    rutinID: 3011,
    rutinKod: 'rtnHuvudRubrik',
    rutinURL: 'Huvudrubrik',
    benamning: 'Huvudrubrik',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVisaInvestering: {
    rutinID: 3012,
    rutinKod: 'rtnVisaInvestering',
    rutinURL: 'Investeringar',
    benamning: 'Investeringar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnNyNedskrivning: {
    rutinID: 3013,
    rutinKod: 'rtnNyNedskrivning',
    rutinURL: 'Nedskrivning',
    benamning: 'Nedskrivning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnNyAvyttr: {
    rutinID: 3014,
    rutinKod: 'rtnNyAvyttr',
    rutinURL: 'AvyttringUtrangering',
    benamning: 'Avyttring/utrangering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPagaendeInvestering: {
    rutinID: 3015,
    rutinKod: 'rtnPagaendeInvestering',
    rutinURL: 'PagaendeInvesteringar',
    benamning: 'Pågående investeringar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOmklassificering: {
    rutinID: 3016,
    rutinKod: 'rtnOmklassificering',
    rutinURL: 'OmklassificeringTillKostnadskonto',
    benamning: 'Omklassificering till kostnadskonto',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnMakuleraAvrakning: {
    rutinID: 3017,
    rutinKod: 'rtnMakuleraAvrakning',
    rutinURL: 'MakuleraAvskrivning',
    benamning: 'Makulera avskrivning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVerksamhetskod: {
    rutinID: 3018,
    rutinKod: 'rtnVerksamhetskod',
    rutinURL: 'Verksamhetskod',
    benamning: 'Verksamhetskod',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAtgardskod: {
    rutinID: 3019,
    rutinKod: 'rtnAtgardskod',
    rutinURL: 'Atgardskod',
    benamning: 'Åtgärdskod',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnImporteraTillgangar: {
    rutinID: 3020,
    rutinKod: 'rtnImporteraTillgangar',
    rutinURL: 'ImporteraAnlaggningstillgangar',
    benamning: 'Importera anläggningstillgångar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKomponent: {
    rutinID: 3021,
    rutinKod: 'rtnKomponent',
    rutinURL: 'Komponenttyp',
    benamning: 'Komponenttyp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnByteInvesteringskonto: {
    rutinID: 3022,
    rutinKod: 'rtnByteInvesteringskonto',
    rutinURL: 'ByteAvInvesteringskonto',
    benamning: 'Byte av investeringskonto',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnInventeringsansvarig: {
    rutinID: 3023,
    rutinKod: 'rtnInventeringsansvarig',
    rutinURL: 'Inventeringsansvariga',
    benamning: 'Inventeringsansvariga',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnInventeringsomgang: {
    rutinID: 3024,
    rutinKod: 'rtnInventeringsomgang',
    rutinURL: 'Inventeringsomgang',
    benamning: 'Inventeringsomgång',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFordelningsmall: {
    rutinID: 3025,
    rutinKod: 'rtnFordelningsmall',
    rutinURL: 'Fordelningsmall',
    benamning: 'Fördelningsmall',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnForbruknInvRader: {
    rutinID: 3026,
    rutinKod: 'rtnForbruknInvRader',
    rutinURL: 'ForbrukningsinvRader',
    benamning: 'Förbrukningsinv.rader',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSKVAutoAvskr: {
    rutinID: 3027,
    rutinKod: 'rtnSKVAutoAvskr',
    rutinURL: 'BeraknaSkattemassigaAvskrivningar',
    benamning: 'Beräkna skattemässiga avskrivningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFaktura: {
    rutinID: 4002,
    rutinKod: 'rtnFaktura',
    rutinURL: 'Fakturering',
    benamning: 'Fakturering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturalayout: {
    rutinID: 4003,
    rutinKod: 'rtnFakturalayout',
    rutinURL: 'Fakturalayout',
    benamning: 'Fakturalayout',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSaljare: {
    rutinID: 4004,
    rutinKod: 'rtnSaljare',
    rutinURL: 'Saljare',
    benamning: 'Säljare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFaktureringsgrupp: {
    rutinID: 4005,
    rutinKod: 'rtnFaktureringsgrupp',
    rutinURL: 'Faktureringsgrupp',
    benamning: 'Faktureringsgrupp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKreditorder: {
    rutinID: 4006,
    rutinKod: 'rtnKreditorder',
    rutinURL: 'Kreditorder',
    benamning: 'Kreditorder',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturaUppslag: {
    rutinID: 4007,
    rutinKod: 'rtnFakturaUppslag',
    rutinURL: 'ValjDebetfaktura',
    benamning: 'Välj debetfaktura',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOrderkategori: {
    rutinID: 4008,
    rutinKod: 'rtnOrderkategori',
    rutinURL: 'Orderkategori',
    benamning: 'Orderkategori',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPrisavtal: {
    rutinID: 4009,
    rutinKod: 'rtnPrisavtal',
    rutinURL: 'Prisavtal',
    benamning: 'Prisavtal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOrderrad: {
    rutinID: 4010,
    rutinKod: 'rtnOrderrad',
    rutinURL: 'Orderrader',
    benamning: 'Orderrader',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnImporteraOrderunderlag: {
    rutinID: 4011,
    rutinKod: 'rtnImporteraOrderunderlag',
    rutinURL: 'ImporteraOrderunderlag',
    benamning: 'Importera orderunderlag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOrderunderlag: {
    rutinID: 4012,
    rutinKod: 'rtnOrderunderlag',
    rutinURL: 'Orderunderlag',
    benamning: 'Orderunderlag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRantefakturering: {
    rutinID: 4013,
    rutinKod: 'rtnRantefakturering',
    rutinURL: 'Drojsmalsrantefakturering',
    benamning: 'Dröjsmålsräntefakturering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRanteomgang: {
    rutinID: 4014,
    rutinKod: 'rtnRanteomgang',
    rutinURL: 'Drojsmalsranteomgang',
    benamning: 'Dröjsmålsränteomgång',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOrdermottagningsvag: {
    rutinID: 4055,
    rutinKod: 'rtnOrdermottagningsvag',
    rutinURL: 'Ordermottagningsvag',
    benamning: 'Ordermottagningsväg',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnScheduler: {
    rutinID: 4056,
    rutinKod: 'rtnScheduler',
    rutinURL: 'Schemalaggaren',
    benamning: 'Schemaläggaren',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFlerbolagshantering: {
    rutinID: 4057,
    rutinKod: 'rtnFlerbolagshantering',
    rutinURL: 'Flerbolagshantering',
    benamning: 'Flerbolagshantering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSIEMottagningsvag: {
    rutinID: 4058,
    rutinKod: 'rtnSIEMottagningsvag',
    rutinURL: 'SIEMottagningsvag',
    benamning: 'SIE-mottagningsväg',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUsersMall: {
    rutinID: 4059,
    rutinKod: 'rtnUsersMall',
    rutinURL: 'GBSRoller',
    benamning: 'GBS-roller',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKremationsjournal: {
    rutinID: 5001,
    rutinKod: 'rtnKremationsjournal',
    rutinURL: 'Kremationsjournal',
    benamning: 'Kremationsjournal',
    leveransstatus: Leveransstatus.Alfa,
  },
  optKrematorie: {
    rutinID: 5002,
    rutinKod: 'optKrematorie',
    rutinURL: 'Krematorier',
    benamning: 'Krematorier',
    leveransstatus: Leveransstatus.Alfa,
  },
  optBegravningsplats: {
    rutinID: 5003,
    rutinKod: 'optBegravningsplats',
    rutinURL: 'Begravningsplatser',
    benamning: 'Begravningsplatser',
    leveransstatus: Leveransstatus.Alfa,
  },
  optKGardAnnanOrt: {
    rutinID: 5004,
    rutinKod: 'optKGardAnnanOrt',
    rutinURL: 'KyrkogardAnnanOrt',
    benamning: 'Kyrkogård annan ort',
    leveransstatus: Leveransstatus.Alfa,
  },
  optKremRapportLayout: {
    rutinID: 5005,
    rutinKod: 'optKremRapportLayout',
    rutinURL: 'Kremationsblankettlayouter',
    benamning: 'Kremationsblankettlayouter',
    leveransstatus: Leveransstatus.Alfa,
  },
  optKremlistor: {
    rutinID: 5006,
    rutinKod: 'optKremlistor',
    rutinURL: 'Kremationsstatistik',
    benamning: 'Kremationsstatistik',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAktuellaKremationer: {
    rutinID: 5007,
    rutinKod: 'rtnAktuellaKremationer',
    rutinURL: 'AktuellaKremationer',
    benamning: 'Aktuella kremationer',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSekretessKremation: {
    rutinID: 5008,
    rutinKod: 'rtnSekretessKremation',
    rutinURL: 'SekretessbehorighetKremation',
    benamning: 'Sekretessbehörighet Kremation',
    leveransstatus: Leveransstatus.Active,
  },
  rtnKundkategori: {
    rutinID: 6003,
    rutinKod: 'rtnKundkategori',
    rutinURL: 'Kundkategori',
    benamning: 'Kundkategori',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnManuellInbetalning: {
    rutinID: 6004,
    rutinKod: 'rtnManuellInbetalning',
    rutinURL: 'ManuellInbetalning',
    benamning: 'Manuell inbetalning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBokforingsjournal: {
    rutinID: 6005,
    rutinKod: 'rtnBokforingsjournal',
    rutinURL: 'Bokforingsjournal',
    benamning: 'Bokföringsjournal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKund: {
    rutinID: 6006,
    rutinKod: 'rtnKund',
    rutinURL: 'Kunder',
    benamning: 'Kunder',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAutomatiskInbetalning: {
    rutinID: 6007,
    rutinKod: 'rtnAutomatiskInbetalning',
    rutinURL: 'InbetalningarKOBOchAutogiro',
    benamning: 'Inbetalningar KOB och Autogiro',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKreditering: {
    rutinID: 6008,
    rutinKod: 'rtnKreditering',
    rutinURL: 'Kreditering',
    benamning: 'Kreditering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUtbetalningtillgodohavande: {
    rutinID: 6009,
    rutinKod: 'rtnUtbetalningtillgodohavande',
    rutinURL: 'UtbetalningAvTillgodohavande',
    benamning: 'Utbetalning av tillgodohavande',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnMakuleraHandelseKund: {
    rutinID: 6010,
    rutinKod: 'rtnMakuleraHandelseKund',
    rutinURL: 'JusteraMakuleraKundreskontra',
    benamning: 'Justera/makulera kundreskontra',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBeraknaTillgodoranta: {
    rutinID: 6011,
    rutinKod: 'rtnBeraknaTillgodoranta',
    rutinURL: 'BeraknaTillgodoranta',
    benamning: 'Beräkna tillgodoränta',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKravutskrift: {
    rutinID: 6012,
    rutinKod: 'rtnKravutskrift',
    rutinURL: 'Kravutskrift',
    benamning: 'Kravutskrift',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKrKontoAvstamning: {
    rutinID: 6013,
    rutinKod: 'rtnKrKontoAvstamning',
    rutinURL: 'AvstamningKundreskontra',
    benamning: 'Avstämning kundreskontra',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBetalaKontofaktura: {
    rutinID: 6014,
    rutinKod: 'rtnBetalaKontofaktura',
    rutinURL: 'BetalningAvBankkontofakturor',
    benamning: 'Betalning av bankkontofakturor',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRegleraInternfakturor: {
    rutinID: 6015,
    rutinKod: 'rtnRegleraInternfakturor',
    rutinURL: 'BetalningAvInternfakturor',
    benamning: 'Betalning av internfakturor',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnMedgivande: {
    rutinID: 6016,
    rutinKod: 'rtnMedgivande',
    rutinURL: 'SkickaMedgivandeForAutogiro',
    benamning: 'Skicka medgivande för autogiro',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAutogirobet: {
    rutinID: 6017,
    rutinKod: 'rtnAutogirobet',
    rutinURL: 'Autogirobetalningar',
    benamning: 'Autogirobetalningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  optMallKund: {
    rutinID: 6018,
    rutinKod: 'optMallKund',
    rutinURL: 'Mallkunder',
    benamning: 'Mallkunder',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKundfakturaanalys: {
    rutinID: 6019,
    rutinKod: 'rtnKundfakturaanalys',
    rutinURL: 'Kundfakturaanalys',
    benamning: 'Kundfakturaanalys',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKravomgang: {
    rutinID: 6020,
    rutinKod: 'rtnKravomgang',
    rutinURL: 'Kravomgang',
    benamning: 'Kravomgång',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKundfakturabunt: {
    rutinID: 6021,
    rutinKod: 'rtnKundfakturabunt',
    rutinURL: 'Kundfakturabunt',
    benamning: 'Kundfakturabunt',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBetalningsfiler: {
    rutinID: 6022,
    rutinKod: 'rtnBetalningsfiler',
    rutinURL: 'InbetalningarBGPG',
    benamning: 'Inbetalningar BG/PG',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnInbetalningsvag: {
    rutinID: 6023,
    rutinKod: 'rtnInbetalningsvag',
    rutinURL: 'Inbetalningsvag',
    benamning: 'Inbetalningsväg',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLicenser: {
    rutinID: 6024,
    rutinKod: 'rtnLicenser',
    rutinURL: 'Licenser',
    benamning: 'Licenser',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUtbetalningKreditfaktura: {
    rutinID: 6025,
    rutinKod: 'rtnUtbetalningKreditfaktura',
    rutinURL: 'UtbetalningAvKreditfaktura',
    benamning: 'Utbetalning av kreditfaktura',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKundfakturahandelser: {
    rutinID: 6026,
    rutinKod: 'rtnKundfakturahandelser',
    rutinURL: 'Kundfakturahandelser',
    benamning: 'Kundfakturahändelser',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAterrappAgresso: {
    rutinID: 6027,
    rutinKod: 'rtnAterrappAgresso',
    rutinURL: 'AterredovisningFranAgresso',
    benamning: 'Återredovisning från Agresso',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAterrappOrderDynamic: {
    rutinID: 6028,
    rutinKod: 'rtnAterrappOrderDynamic',
    rutinURL: 'BetalningsinformationFranDynamics',
    benamning: 'Betalningsinformation från Dynamics',
    leveransstatus: Leveransstatus.Active,
  },
  rtnUsers: {
    rutinID: 7001,
    rutinKod: 'rtnUsers',
    rutinURL: 'Anvandare',
    benamning: 'Användare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRoller: {
    rutinID: 7002,
    rutinKod: 'rtnRoller',
    rutinURL: 'Roller',
    benamning: 'Roller',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAvenyGrupper: {
    rutinID: 7003,
    rutinKod: 'rtnAvenyGrupper',
    rutinURL: 'Bokforingsgrupper',
    benamning: 'Bokföringsgrupper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnNummerserier: {
    rutinID: 7004,
    rutinKod: 'rtnNummerserier',
    rutinURL: 'Nummerserier',
    benamning: 'Nummerserier',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRanteTabell: {
    rutinID: 7005,
    rutinKod: 'rtnRanteTabell',
    rutinURL: 'Rantetabell',
    benamning: 'Räntetabell',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnMoms: {
    rutinID: 7006,
    rutinKod: 'rtnMoms',
    rutinURL: 'Moms',
    benamning: 'Moms',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBokfar: {
    rutinID: 7007,
    rutinKod: 'rtnBokfar',
    rutinURL: 'Bokforingsar',
    benamning: 'Bokföringsår',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBank: {
    rutinID: 7008,
    rutinKod: 'rtnBank',
    rutinURL: 'Banker',
    benamning: 'Banker',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKravrutin: {
    rutinID: 7009,
    rutinKod: 'rtnKravrutin',
    rutinURL: 'Kravrutiner',
    benamning: 'Kravrutiner',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBetalningsvillkor: {
    rutinID: 7010,
    rutinKod: 'rtnBetalningsvillkor',
    rutinURL: 'Betalningsvillkor',
    benamning: 'Betalningsvillkor',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBetalningssatt: {
    rutinID: 7011,
    rutinKod: 'rtnBetalningssatt',
    rutinURL: 'Inbetalningssatt',
    benamning: 'Inbetalningssätt',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLeveransvillkor: {
    rutinID: 7012,
    rutinKod: 'rtnLeveransvillkor',
    rutinURL: 'Leveransvillkor',
    benamning: 'Leveransvillkor',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnValuta: {
    rutinID: 7013,
    rutinKod: 'rtnValuta',
    rutinURL: 'Valuta',
    benamning: 'Valuta',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLand: {
    rutinID: 7014,
    rutinKod: 'rtnLand',
    rutinURL: 'Land',
    benamning: 'Land',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSprak: {
    rutinID: 7015,
    rutinKod: 'rtnSprak',
    rutinURL: 'Sprak',
    benamning: 'Språk',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTitlar: {
    rutinID: 7016,
    rutinKod: 'rtnTitlar',
    rutinURL: 'Titlar',
    benamning: 'Titlar',
    leveransstatus: Leveransstatus.Alfa,
  },
  optLKF: {
    rutinID: 7017,
    rutinKod: 'optLKF',
    rutinURL: 'LKFKoder',
    benamning: 'LKF-koder',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUtbetalningssatt: {
    rutinID: 7018,
    rutinKod: 'rtnUtbetalningssatt',
    rutinURL: 'Utbetalningssatt',
    benamning: 'Utbetalningssätt',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUtbetalningsvag: {
    rutinID: 7019,
    rutinKod: 'rtnUtbetalningsvag',
    rutinURL: 'Utbetalningsvagar',
    benamning: 'Utbetalningsvägar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBokningsgrupper: {
    rutinID: 7020,
    rutinKod: 'rtnBokningsgrupper',
    rutinURL: 'Bokningsgrupper',
    benamning: 'Bokningsgrupper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSystemOrg: {
    rutinID: 7022,
    rutinKod: 'rtnSystemOrg',
    rutinURL: 'Bolagsuppgifter',
    benamning: 'Bolagsuppgifter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnNummerserierUpd: {
    rutinID: 7023,
    rutinKod: 'rtnNummerserierUpd',
    rutinURL: 'UppdateraNummerserier',
    benamning: 'Uppdatera nummerserier',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRapportLayout: {
    rutinID: 7024,
    rutinKod: 'rtnRapportLayout',
    rutinURL: 'Brevlayout',
    benamning: 'Brevlayout',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLogg: {
    rutinID: 7025,
    rutinKod: 'rtnLogg',
    rutinURL: 'Loggdefinitioner',
    benamning: 'Loggdefinitioner',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKonteringskod: {
    rutinID: 7026,
    rutinKod: 'rtnKonteringskod',
    rutinURL: 'Konteringskoder',
    benamning: 'Konteringskoder',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUndo: {
    rutinID: 7027,
    rutinKod: 'rtnUndo',
    rutinURL: 'AngraSammanslagningAvAdress',
    benamning: 'Ångra sammanslagning av adress',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAutogiromall: {
    rutinID: 7028,
    rutinKod: 'rtnAutogiromall',
    rutinURL: 'Autogiromallar',
    benamning: 'Autogiromallar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPostnr: {
    rutinID: 7029,
    rutinKod: 'rtnPostnr',
    rutinURL: 'Postnummer',
    benamning: 'Postnummer',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUrval: {
    rutinID: 7030,
    rutinKod: 'rtnUrval',
    rutinURL: 'Kontourval',
    benamning: 'Kontourval',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArbetsstalle: {
    rutinID: 7031,
    rutinKod: 'rtnArbetsstalle',
    rutinURL: 'Arbetsstallen',
    benamning: 'Arbetsställen',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEkostyr: {
    rutinID: 7032,
    rutinKod: 'rtnEkostyr',
    rutinURL: 'InstallningarEkostyr',
    benamning: 'Inställningar Ekostyr',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFaktGruppSkotsel: {
    rutinID: 7033,
    rutinKod: 'rtnFaktGruppSkotsel',
    rutinURL: 'ByteAvAvvikandeFaktGrupp',
    benamning: 'Byte av avvikande fakt grupp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKnavUpdate: {
    rutinID: 7034,
    rutinKod: 'rtnKnavUpdate',
    rutinURL: 'UppdateraAdresser',
    benamning: 'Uppdatera adresser',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBlankettStyr: {
    rutinID: 7035,
    rutinKod: 'rtnBlankettStyr',
    rutinURL: 'BlanketterOchWordrapporter',
    benamning: 'Blanketter och Wordrapporter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVisaRapporter: {
    rutinID: 7036,
    rutinKod: 'rtnVisaRapporter',
    rutinURL: 'OversiktRapporter',
    benamning: 'Översikt rapporter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVisaUrval: {
    rutinID: 7037,
    rutinKod: 'rtnVisaUrval',
    rutinURL: 'OversiktUrval',
    benamning: 'Översikt urval',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnClearingArtiklar: {
    rutinID: 7038,
    rutinKod: 'rtnClearingArtiklar',
    rutinURL: 'KOBClearingartiklar',
    benamning: 'KOB-clearingartiklar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturaformedlare: {
    rutinID: 7039,
    rutinKod: 'rtnFakturaformedlare',
    rutinURL: 'Fakturaformedlare',
    benamning: 'Fakturaförmedlare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturakoder: {
    rutinID: 7040,
    rutinKod: 'rtnFakturakoder',
    rutinURL: 'Fakturakoder',
    benamning: 'Fakturakoder',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturaradskoder: {
    rutinID: 7041,
    rutinKod: 'rtnFakturaradskoder',
    rutinURL: 'Fakturaradskoder',
    benamning: 'Fakturaradskoder',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSystemSettings: {
    rutinID: 7042,
    rutinKod: 'rtnSystemSettings',
    rutinURL: 'Systeminstallningar',
    benamning: 'Systeminställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBevakning: {
    rutinID: 7043,
    rutinKod: 'rtnBevakning',
    rutinURL: 'OversiktBevakning',
    benamning: 'Översikt bevakning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnImportXML: {
    rutinID: 7045,
    rutinKod: 'rtnImportXML',
    rutinURL: 'UppdateraMusikbasen',
    benamning: 'Uppdatera Musikbasen',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnExportXML: {
    rutinID: 7046,
    rutinKod: 'rtnExportXML',
    rutinURL: 'ExportDBToXML',
    benamning: 'Export DB to XML',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPublishNews: {
    rutinID: 7048,
    rutinKod: 'rtnPublishNews',
    rutinURL: 'PubliceraNyheterTillAveny',
    benamning: 'Publicera nyheter till Aveny',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTestSKK: {
    rutinID: 7049,
    rutinKod: 'rtnTestSKK',
    rutinURL: 'TestaSvenskaKyrkansKalender',
    benamning: 'Testa Svenska Kyrkans Kalender',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKOBIntegration: {
    rutinID: 7050,
    rutinKod: 'rtnKOBIntegration',
    rutinURL: 'KOBIntegration',
    benamning: 'KOBIntegration',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRensaSKK: {
    rutinID: 7051,
    rutinKod: 'rtnRensaSKK',
    rutinURL: 'RensaSvenskaKyrkansKalender',
    benamning: 'Rensa Svenska Kyrkans Kalender',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTestXbridge: {
    rutinID: 7052,
    rutinKod: 'rtnTestXbridge',
    rutinURL: 'TestaXBridge',
    benamning: 'Testa XBridge',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnCommunicator: {
    rutinID: 7053,
    rutinKod: 'rtnCommunicator',
    rutinURL: 'SchemalaggningKommunikator',
    benamning: 'Schemaläggning Kommunikator',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUDs: {
    rutinID: 7054,
    rutinKod: 'rtnUDs',
    rutinURL: 'EgendefinieradeFaltOchNoteringar',
    benamning: 'Egendefinierade fält och noteringar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKommunikationsfil: {
    rutinID: 7055,
    rutinKod: 'rtnKommunikationsfil',
    rutinURL: 'Kommunikationsfil',
    benamning: 'Kommunikationsfil',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUppdateraGASStandard: {
    rutinID: 7056,
    rutinKod: 'rtnUppdateraGASStandard',
    rutinURL: 'UppdateraGASStandard',
    benamning: 'Uppdatera GAS-standard',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnIgangkorningGAS: {
    rutinID: 7057,
    rutinKod: 'rtnIgangkorningGAS',
    rutinURL: 'IgangkorningGAS',
    benamning: 'Igångkörning GAS',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFramsidan: {
    rutinID: 7058,
    rutinKod: 'rtnFramsidan',
    rutinURL: 'Framsidan',
    benamning: 'Framsidan',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFormedlingsuppdrag: {
    rutinID: 7059,
    rutinKod: 'rtnFormedlingsuppdrag',
    rutinURL: 'Formedlingsuppdrag',
    benamning: 'Förmedlingsuppdrag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKonverteringar: {
    rutinID: 7061,
    rutinKod: 'rtnKonverteringar',
    rutinURL: 'Konverteringar',
    benamning: 'Konverteringar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAdressanvandning: {
    rutinID: 7062,
    rutinKod: 'rtnAdressanvandning',
    rutinURL: 'Registerforteckning',
    benamning: 'Registerförteckning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRegisterutdrag: {
    rutinID: 7063,
    rutinKod: 'rtnRegisterutdrag',
    rutinURL: 'Registerutdrag',
    benamning: 'Registerutdrag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGDPRInventering: {
    rutinID: 7064,
    rutinKod: 'rtnGDPRInventering',
    rutinURL: 'GDPRInventering',
    benamning: 'GDPR Inventering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGDPRPersonkategorier: {
    rutinID: 7065,
    rutinKod: 'rtnGDPRPersonkategorier',
    rutinURL: 'GDPRRegister',
    benamning: 'GDPR Register',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnNyckeltal: {
    rutinID: 7066,
    rutinKod: 'rtnNyckeltal',
    rutinURL: 'Nyckeltal',
    benamning: 'Nyckeltal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnProcesser: {
    rutinID: 7067,
    rutinKod: 'rtnProcesser',
    rutinURL: 'Processer',
    benamning: 'Processer',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnStatistikinstallningar: {
    rutinID: 7068,
    rutinKod: 'rtnStatistikinstallningar',
    rutinURL: 'Hemforsamlingar',
    benamning: 'Hemförsamlingar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnJobb: {
    rutinID: 7069,
    rutinKod: 'rtnJobb',
    rutinURL: 'BakgrundsjobbWeb',
    benamning: 'Bakgrundsjobb (web)',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnIntegrationMedFlex: {
    rutinID: 7070,
    rutinKod: 'rtnIntegrationMedFlex',
    rutinURL: 'IntegrationMedFlex',
    benamning: 'IntegrationMedFlex',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPersonlogg: {
    rutinID: 7071,
    rutinKod: 'rtnPersonlogg',
    rutinURL: 'Personvisningslogg',
    benamning: 'Personvisningslogg',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnJobbA: {
    rutinID: 7072,
    rutinKod: 'rtnJobbA',
    rutinURL: 'Bakgrundsjobb',
    benamning: 'Bakgrundsjobb',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnIgangkorningEjGAS: {
    rutinID: 7073,
    rutinKod: 'rtnIgangkorningEjGAS',
    rutinURL: 'IgangkorningEjGAS',
    benamning: 'Igångkörning, ej GAS',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSYSOptions: {
    rutinID: 7074,
    rutinKod: 'rtnSYSOptions',
    rutinURL: 'SYSOptions',
    benamning: 'SYSOptions',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDigitalaSigneringar: {
    rutinID: 7075,
    rutinKod: 'rtnDigitalaSigneringar',
    rutinURL: 'DigitalaSigneringar',
    benamning: 'Digitala signeringar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGASOut: {
    rutinID: 7076,
    rutinKod: 'rtnGASOut',
    rutinURL: 'MigreringFranAvenyGAS',
    benamning: 'Migrering från Aveny GAS',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTest1: {
    rutinID: 7902,
    rutinKod: 'rtnTest1',
    rutinURL: 'Test1',
    benamning: 'Test 1',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTest2: {
    rutinID: 7903,
    rutinKod: 'rtnTest2',
    rutinURL: 'Test2',
    benamning: 'Test 2',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTest3: {
    rutinID: 7904,
    rutinKod: 'rtnTest3',
    rutinURL: 'Test3',
    benamning: 'Test 3',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTest4: {
    rutinID: 7905,
    rutinKod: 'rtnTest4',
    rutinURL: 'Test4',
    benamning: 'Test 4',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTest5: {
    rutinID: 7906,
    rutinKod: 'rtnTest5',
    rutinURL: 'Test5',
    benamning: 'Test 5',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTest6: {
    rutinID: 7907,
    rutinKod: 'rtnTest6',
    rutinURL: 'Test6',
    benamning: 'Test 6',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTest7: {
    rutinID: 7908,
    rutinKod: 'rtnTest7',
    rutinURL: 'Test7',
    benamning: 'Test 7',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTest8: {
    rutinID: 7909,
    rutinKod: 'rtnTest8',
    rutinURL: 'Test8',
    benamning: 'Test 8',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTest9: {
    rutinID: 7910,
    rutinKod: 'rtnTest9',
    rutinURL: 'Test9',
    benamning: 'Test 9',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTest10: {
    rutinID: 7911,
    rutinKod: 'rtnTest10',
    rutinURL: 'Test10',
    benamning: 'Test 10',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDemo1: {
    rutinID: 7921,
    rutinKod: 'rtnDemo1',
    rutinURL: 'Demorutin1',
    benamning: 'Demorutin 1',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOrgPersLok: {
    rutinID: 8004,
    rutinKod: 'rtnOrgPersLok',
    rutinURL: 'Organisationer',
    benamning: 'Organisationer',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOPLInternalRoutine: {
    rutinID: 8005,
    rutinKod: 'rtnOPLInternalRoutine',
    rutinURL: 'DeladeAdresser',
    benamning: 'Delade adresser',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOPLFind: {
    rutinID: 8006,
    rutinKod: 'rtnOPLFind',
    rutinURL: 'Deltagare_3',
    benamning: 'Deltagare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAdresser_HarUtgatt: {
    rutinID: 8007,
    rutinKod: 'rtnAdresser_HarUtgatt',
    rutinURL: 'Adressbok',
    benamning: 'Adressbok',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnForsamlingar: {
    rutinID: 8008,
    rutinKod: 'rtnForsamlingar',
    rutinURL: 'PastoratOchForsamlingar',
    benamning: 'Pastorat och församlingar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAdressbokKontakter: {
    rutinID: 8009,
    rutinKod: 'rtnAdressbokKontakter',
    rutinURL: 'AdressbokKontakter',
    benamning: 'Adressbok, Kontakter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTvist: {
    rutinID: 8010,
    rutinKod: 'rtnTvist',
    rutinURL: 'Tvist',
    benamning: 'Tvist',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAvliden: {
    rutinID: 8011,
    rutinKod: 'rtnAvliden',
    rutinURL: 'Avlidna',
    benamning: 'Avlidna',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArtiklar: {
    rutinID: 9001,
    rutinKod: 'rtnArtiklar',
    rutinURL: 'Artiklar',
    benamning: 'Artiklar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnEnhet: {
    rutinID: 9002,
    rutinKod: 'rtnEnhet',
    rutinURL: 'Enhet',
    benamning: 'Enhet',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArtikelgrupp: {
    rutinID: 9003,
    rutinKod: 'rtnArtikelgrupp',
    rutinURL: 'Artikelgrupp',
    benamning: 'Artikelgrupp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPrislista: {
    rutinID: 9004,
    rutinKod: 'rtnPrislista',
    rutinURL: 'Prislista',
    benamning: 'Prislista',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturatext: {
    rutinID: 9005,
    rutinKod: 'rtnFakturatext',
    rutinURL: 'StandardtextOrder',
    benamning: 'Standardtext, order',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLevkategori: {
    rutinID: 10001,
    rutinKod: 'rtnLevkategori',
    rutinURL: 'Leverantorskategori',
    benamning: 'Leverantörskategori',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLeverantorer: {
    rutinID: 10002,
    rutinKod: 'rtnLeverantorer',
    rutinURL: 'Leverantorer',
    benamning: 'Leverantörer',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAttestanter: {
    rutinID: 10003,
    rutinKod: 'rtnAttestanter',
    rutinURL: 'Attestanter',
    benamning: 'Attestanter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAnkomstregistrering: {
    rutinID: 10004,
    rutinKod: 'rtnAnkomstregistrering',
    rutinURL: 'Ankomstregistrering',
    benamning: 'Ankomstregistrering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDefinitivbokning: {
    rutinID: 10005,
    rutinKod: 'rtnDefinitivbokning',
    rutinURL: 'Definitivbokning',
    benamning: 'Definitivbokning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUtbetalningsuppdrag: {
    rutinID: 10006,
    rutinKod: 'rtnUtbetalningsuppdrag',
    rutinURL: 'Utbetalningsorder',
    benamning: 'Utbetalningsorder',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBokfutbet: {
    rutinID: 10007,
    rutinKod: 'rtnBokfutbet',
    rutinURL: 'BokforUtbetalningsuppdrag',
    benamning: 'Bokför utbetalningsuppdrag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnMakuleraHandelseLeverantor: {
    rutinID: 10008,
    rutinKod: 'rtnMakuleraHandelseLeverantor',
    rutinURL: 'JusteraMakuleraLevReskontra',
    benamning: 'Justera/makulera lev.reskontra',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnJusteraLevfakturabelopp: {
    rutinID: 10009,
    rutinKod: 'rtnJusteraLevfakturabelopp',
    rutinURL: 'JusteraBeloppForLevFaktura',
    benamning: 'Justera belopp för lev.faktura',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKontoAvstamning: {
    rutinID: 10010,
    rutinKod: 'rtnKontoAvstamning',
    rutinURL: 'AvstamningLeverantorsskulder',
    benamning: 'Avstämning leverantörsskulder',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLRKvartalsStatistik: {
    rutinID: 10011,
    rutinKod: 'rtnLRKvartalsStatistik',
    rutinURL: 'StatistikUtbetalningsuppdrag',
    benamning: 'Statistik utbetalningsuppdrag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAnkregAvstamning: {
    rutinID: 10012,
    rutinKod: 'rtnAnkregAvstamning',
    rutinURL: 'AvstamningAnkomstregFakturor',
    benamning: 'Avstämning ankomstreg. fakturor',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturabunt: {
    rutinID: 10013,
    rutinKod: 'rtnFakturabunt',
    rutinURL: 'Leverantorsfakturabunt',
    benamning: 'Leverantörsfakturabunt',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturabevakning: {
    rutinID: 10014,
    rutinKod: 'rtnFakturabevakning',
    rutinURL: 'Fakturabevakning',
    benamning: 'Fakturabevakning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAttestGrupp: {
    rutinID: 10015,
    rutinKod: 'rtnAttestGrupp',
    rutinURL: 'Attestgrupp',
    benamning: 'Attestgrupp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAttestOmrade: {
    rutinID: 10016,
    rutinKod: 'rtnAttestOmrade',
    rutinURL: 'Attestomrade',
    benamning: 'Attestområde',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFakturamottagningsvag: {
    rutinID: 10017,
    rutinKod: 'rtnFakturamottagningsvag',
    rutinURL: 'Fakturamottagningsvag',
    benamning: 'Fakturamottagningsväg',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAttestforslag: {
    rutinID: 10018,
    rutinKod: 'rtnAttestforslag',
    rutinURL: 'Leverantorsfakturareferens',
    benamning: 'Leverantörsfakturareferens',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLevFakturor: {
    rutinID: 10019,
    rutinKod: 'rtnLevFakturor',
    rutinURL: 'Leverantorsfakturor',
    benamning: 'Leverantörsfakturor',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBetalRedov: {
    rutinID: 10020,
    rutinKod: 'rtnBetalRedov',
    rutinURL: 'AterredovisningAvUtbetalningar',
    benamning: 'Återredovisning av utbetalningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLeverantorBetSatt: {
    rutinID: 10021,
    rutinKod: 'rtnLeverantorBetSatt',
    rutinURL: 'LeverantorensBetalningssatt',
    benamning: 'Leverantörens betalningssätt',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVisaLeverantorsAttester: {
    rutinID: 10022,
    rutinKod: 'rtnVisaLeverantorsAttester',
    rutinURL: 'Leverantorsattest',
    benamning: 'Leverantörsattest',
    leveransstatus: Leveransstatus.Active,
  },
  rtnMusikstycke: {
    rutinID: 11001,
    rutinKod: 'rtnMusikstycke',
    rutinURL: 'Musikstycken',
    benamning: 'Musikstycken',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnForfattare: {
    rutinID: 11002,
    rutinKod: 'rtnForfattare',
    rutinURL: 'Forfattare',
    benamning: 'Författare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnForkortningar: {
    rutinID: 11003,
    rutinKod: 'rtnForkortningar',
    rutinURL: 'Forkortningar',
    benamning: 'Förkortningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnMusikgrupper: {
    rutinID: 11004,
    rutinKod: 'rtnMusikgrupper',
    rutinURL: 'Musikgrupper',
    benamning: 'Musikgrupper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUpdateMBAS: {
    rutinID: 11005,
    rutinKod: 'rtnUpdateMBAS',
    rutinURL: 'UppdateraMusikbasen_2',
    benamning: 'Uppdatera Musikbasen',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnNotarkiv: {
    rutinID: 11006,
    rutinKod: 'rtnNotarkiv',
    rutinURL: 'Notarkiv',
    benamning: 'Notarkiv',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFramforanden: {
    rutinID: 11007,
    rutinKod: 'rtnFramforanden',
    rutinURL: 'Framforanden',
    benamning: 'Framföranden',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnNoter: {
    rutinID: 11008,
    rutinKod: 'rtnNoter',
    rutinURL: 'NoterIArkiv',
    benamning: 'Noter i arkiv',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnForlag: {
    rutinID: 11009,
    rutinKod: 'rtnForlag',
    rutinURL: 'Forlag',
    benamning: 'Förlag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDatabaslogg: {
    rutinID: 12001,
    rutinKod: 'rtnDatabaslogg',
    rutinURL: 'Databaslogg',
    benamning: 'Databaslogg',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnProgramAndring: {
    rutinID: 12002,
    rutinKod: 'rtnProgramAndring',
    rutinURL: 'Uppgifter',
    benamning: 'Uppgifter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRutinVal: {
    rutinID: 12003,
    rutinKod: 'rtnRutinVal',
    rutinURL: 'Rutinval',
    benamning: 'Rutinval',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnCreateUpdate: {
    rutinID: 12004,
    rutinKod: 'rtnCreateUpdate',
    rutinURL: 'SkapaUppdatering',
    benamning: 'Skapa uppdatering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAndringsLogg: {
    rutinID: 12005,
    rutinKod: 'rtnAndringsLogg',
    rutinURL: 'Andringslogg',
    benamning: 'Ändringslogg',
    leveransstatus: Leveransstatus.Alfa,
  },
  optVerOptions: {
    rutinID: 12006,
    rutinKod: 'optVerOptions',
    rutinURL: 'AktuellVersion',
    benamning: 'Aktuell version',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnReportFields: {
    rutinID: 12007,
    rutinKod: 'rtnReportFields',
    rutinURL: 'MappaExportattribut',
    benamning: 'Mappa exportattribut',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebSurvey: {
    rutinID: 12008,
    rutinKod: 'rtnWebSurvey',
    rutinURL: 'WebEnkat',
    benamning: 'Web enkät',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFAQ: {
    rutinID: 12009,
    rutinKod: 'rtnFAQ',
    rutinURL: 'FragorOchSvar',
    benamning: 'Frågor och svar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUppdatering: {
    rutinID: 12010,
    rutinKod: 'rtnUppdatering',
    rutinURL: 'ReleaserOchChecklistor',
    benamning: 'Releaser och checklistor',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDiarie: {
    rutinID: 13001,
    rutinKod: 'rtnDiarie',
    rutinURL: 'Arenden',
    benamning: 'Ärenden',
    leveransstatus: Leveransstatus.Alfa,
  },
  optDiarieplan: {
    rutinID: 13002,
    rutinKod: 'optDiarieplan',
    rutinURL: 'StyrvardenDiarieplan',
    benamning: 'Styrvärden diarieplan',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPostlista: {
    rutinID: 13003,
    rutinKod: 'rtnPostlista',
    rutinURL: 'Postlista',
    benamning: 'Postlista',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDiariePlan: {
    rutinID: 13004,
    rutinKod: 'rtnDiariePlan',
    rutinURL: 'Diarieplan',
    benamning: 'Diarieplan',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnHandlaggare: {
    rutinID: 13005,
    rutinKod: 'rtnHandlaggare',
    rutinURL: 'Handlaggare',
    benamning: 'Handläggare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnMottagare: {
    rutinID: 13006,
    rutinKod: 'rtnMottagare',
    rutinURL: 'AvsandareMottagare',
    benamning: 'Avsändare/Mottagare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnHandlingstyp: {
    rutinID: 13007,
    rutinKod: 'rtnHandlingstyp',
    rutinURL: 'Handlingstyp',
    benamning: 'Handlingstyp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDokument: {
    rutinID: 13008,
    rutinKod: 'rtnDokument',
    rutinURL: 'Dokument',
    benamning: 'Dokument',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDiariegrupp: {
    rutinID: 13009,
    rutinKod: 'rtnDiariegrupp',
    rutinURL: 'Diariegrupp',
    benamning: 'Diariegrupp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDIStandardText: {
    rutinID: 13010,
    rutinKod: 'rtnDIStandardText',
    rutinURL: 'RubrikStandardtexter',
    benamning: 'Rubrik, standardtexter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDIStandardTextArkiv: {
    rutinID: 13011,
    rutinKod: 'rtnDIStandardTextArkiv',
    rutinURL: 'ArkivplatsStandardtexter',
    benamning: 'Arkivplats, standardtexter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDIListor: {
    rutinID: 13012,
    rutinKod: 'rtnDIListor',
    rutinURL: 'StyrvardenVisning',
    benamning: 'Styrvärden visning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVisaDiarie: {
    rutinID: 13013,
    rutinKod: 'rtnVisaDiarie',
    rutinURL: 'VisaArenden',
    benamning: 'Visa Ärenden',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVisaPostlista: {
    rutinID: 13014,
    rutinKod: 'rtnVisaPostlista',
    rutinURL: 'VisaPostlista',
    benamning: 'Visa Postlista',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUsersDI: {
    rutinID: 13015,
    rutinKod: 'rtnUsersDI',
    rutinURL: 'AnvandareDiarieinstallningar',
    benamning: 'Användare, diarieinställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFaktureringstyp: {
    rutinID: 14001,
    rutinKod: 'rtnFaktureringstyp',
    rutinURL: 'Faktureringstyp',
    benamning: 'Faktureringstyp',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTIEnhet: {
    rutinID: 14002,
    rutinKod: 'rtnTIEnhet',
    rutinURL: 'Enhet_2',
    benamning: 'Enhet',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTIInstallningar: {
    rutinID: 14003,
    rutinKod: 'rtnTIInstallningar',
    rutinURL: 'InstallningarTidredovisning',
    benamning: 'Inställningar, Tidredovisning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTidredovisningsparametrar: {
    rutinID: 14004,
    rutinKod: 'rtnTidredovisningsparametrar',
    rutinURL: 'Systemparametrar',
    benamning: 'Systemparametrar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVeckoschema: {
    rutinID: 14005,
    rutinKod: 'rtnVeckoschema',
    rutinURL: 'Schema',
    benamning: 'Schema',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRapporteringskod: {
    rutinID: 14006,
    rutinKod: 'rtnRapporteringskod',
    rutinURL: 'Rapporteringskod',
    benamning: 'Rapporteringskod',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAnstalld: {
    rutinID: 14007,
    rutinKod: 'rtnAnstalld',
    rutinURL: 'Anstallda',
    benamning: 'Anställda',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTidregistrering: {
    rutinID: 14008,
    rutinKod: 'rtnTidregistrering',
    rutinURL: 'Tidregistrering',
    benamning: 'Tidregistrering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnArbetsuppgifter: {
    rutinID: 14009,
    rutinKod: 'rtnArbetsuppgifter',
    rutinURL: 'Arbetsuppgifter',
    benamning: 'Arbetsuppgifter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTidGrupp: {
    rutinID: 14010,
    rutinKod: 'rtnTidGrupp',
    rutinURL: 'Tidredovisningsgrupper',
    benamning: 'Tidredovisningsgrupper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTIProjekt: {
    rutinID: 14011,
    rutinKod: 'rtnTIProjekt',
    rutinURL: 'Tidredovisningsprojekt',
    benamning: 'Tidredovisningsprojekt',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPrioritet: {
    rutinID: 14012,
    rutinKod: 'rtnPrioritet',
    rutinURL: 'Prioritetsnivaer',
    benamning: 'Prioritetsnivåer',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTidrapporteringar: {
    rutinID: 14013,
    rutinKod: 'rtnTidrapporteringar',
    rutinURL: 'Tidrapporteringar',
    benamning: 'Tidrapporteringar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnManadsAvslut: {
    rutinID: 14014,
    rutinKod: 'rtnManadsAvslut',
    rutinURL: 'Manadsavslut',
    benamning: 'Månadsavslut',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLoneartKategori: {
    rutinID: 14015,
    rutinKod: 'rtnLoneartKategori',
    rutinURL: 'Rapporteringskodskategori',
    benamning: 'Rapporteringskodskategori',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAnstalldKategori: {
    rutinID: 14016,
    rutinKod: 'rtnAnstalldKategori',
    rutinURL: 'Anstalldskategori',
    benamning: 'Anställdskategori',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnInloggningsStatus: {
    rutinID: 14017,
    rutinKod: 'rtnInloggningsStatus',
    rutinURL: 'Narvarotabla',
    benamning: 'Närvarotablå',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnStampelklocka: {
    rutinID: 14018,
    rutinKod: 'rtnStampelklocka',
    rutinURL: 'Stampelklocka',
    benamning: 'Stämpelklocka',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRapporteringskod2: {
    rutinID: 14019,
    rutinKod: 'rtnRapporteringskod2',
    rutinURL: 'Rapporteringskod2',
    benamning: 'Rapporteringskod 2',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDagschema: {
    rutinID: 14020,
    rutinKod: 'rtnDagschema',
    rutinURL: 'Dagschema',
    benamning: 'Dagschema',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTidbank: {
    rutinID: 14021,
    rutinKod: 'rtnTidbank',
    rutinURL: 'Tidbank',
    benamning: 'Tidbank',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBokforTidrapporteringar: {
    rutinID: 14022,
    rutinKod: 'rtnBokforTidrapporteringar',
    rutinURL: 'BokforTidrapporteringar',
    benamning: 'Bokför Tidrapporteringar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVarningstyper: {
    rutinID: 14023,
    rutinKod: 'rtnVarningstyper',
    rutinURL: 'Varningstyper',
    benamning: 'Varningstyper',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnVarningslista: {
    rutinID: 14024,
    rutinKod: 'rtnVarningslista',
    rutinURL: 'Varningslistor',
    benamning: 'Varningslistor',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnAnstalldBegr: {
    rutinID: 14025,
    rutinKod: 'rtnAnstalldBegr',
    rutinURL: 'MinaRapporteringar',
    benamning: 'Mina rapporteringar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFordelaTid: {
    rutinID: 14026,
    rutinKod: 'rtnFordelaTid',
    rutinURL: 'FordelningAvTid',
    benamning: 'Fördelning av tid',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPeriodregistrering: {
    rutinID: 14027,
    rutinKod: 'rtnPeriodregistrering',
    rutinURL: 'Periodregistrering',
    benamning: 'Periodregistrering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTaBortTidrapportering: {
    rutinID: 14028,
    rutinKod: 'rtnTaBortTidrapportering',
    rutinURL: 'TaBortTidrapportering',
    benamning: 'Ta Bort Tidrapportering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRegistreraForDemo: {
    rutinID: 14029,
    rutinKod: 'rtnRegistreraForDemo',
    rutinURL: 'RegistreraForDemo',
    benamning: 'Registrera för demo',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTIRapport: {
    rutinID: 14030,
    rutinKod: 'rtnTIRapport',
    rutinURL: 'Tidrapport',
    benamning: 'Tidrapport',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSpecTIRapport: {
    rutinID: 14031,
    rutinKod: 'rtnSpecTIRapport',
    rutinURL: 'DefinieraTidrapport',
    benamning: 'Definiera tidrapport',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTIRapportkategori: {
    rutinID: 14032,
    rutinKod: 'rtnTIRapportkategori',
    rutinURL: 'Rapportkategori_2',
    benamning: 'Rapportkategori',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTIRapporthuvud: {
    rutinID: 14033,
    rutinKod: 'rtnTIRapporthuvud',
    rutinURL: 'Sidhuvud_2',
    benamning: 'Sidhuvud',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTIAttest: {
    rutinID: 14034,
    rutinKod: 'rtnTIAttest',
    rutinURL: 'Attest',
    benamning: 'Attest',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTIAttestkategorier: {
    rutinID: 14035,
    rutinKod: 'rtnTIAttestkategorier',
    rutinURL: 'Attestkategorier',
    benamning: 'Attestkategorier',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTIAttestomraden: {
    rutinID: 14036,
    rutinKod: 'rtnTIAttestomraden',
    rutinURL: 'AttestomradenTidredovisning',
    benamning: 'Attestområden, Tidredovisning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLoneunderlag: {
    rutinID: 14037,
    rutinKod: 'rtnLoneunderlag',
    rutinURL: 'Loneunderlag',
    benamning: 'Löneunderlag',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnLonearter: {
    rutinID: 14038,
    rutinKod: 'rtnLonearter',
    rutinURL: 'LonearterTidredovisning',
    benamning: 'Lönearter, Tidredovisning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnRapporteringsobjekt: {
    rutinID: 14039,
    rutinKod: 'rtnRapporteringsobjekt',
    rutinURL: 'Rapporteringsobjekt',
    benamning: 'Rapporteringsobjekt',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnTidrapporteringBegr: {
    rutinID: 14040,
    rutinKod: 'rtnTidrapporteringBegr',
    rutinURL: 'MinTidregistrering',
    benamning: 'Min tidregistrering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPeriodregistreringBegr: {
    rutinID: 14041,
    rutinKod: 'rtnPeriodregistreringBegr',
    rutinURL: 'MinPeriodregistrering',
    benamning: 'Min periodregistrering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnFordelaTidBegr: {
    rutinID: 14042,
    rutinKod: 'rtnFordelaTidBegr',
    rutinURL: 'MinFordelningAvTid',
    benamning: 'Min fördelning av tid',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnPafyllSemDagar: {
    rutinID: 14043,
    rutinKod: 'rtnPafyllSemDagar',
    rutinURL: 'PafyllningSemesterdagar',
    benamning: 'Påfyllning semesterdagar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnDagrapporteringar: {
    rutinID: 14044,
    rutinKod: 'rtnDagrapporteringar',
    rutinURL: 'Dagrapporteringar',
    benamning: 'Dagrapporteringar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSchemaOB: {
    rutinID: 14045,
    rutinKod: 'rtnSchemaOB',
    rutinURL: 'OBSchema',
    benamning: 'OB-Schema',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnOBRegistrering: {
    rutinID: 14046,
    rutinKod: 'rtnOBRegistrering',
    rutinURL: 'OBRegistrering',
    benamning: 'OB-Registrering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnStampel: {
    rutinID: 14047,
    rutinKod: 'rtnStampel',
    rutinURL: 'Stamplingar',
    benamning: 'Stämplingar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebKontoAnalys: {
    rutinID: 15001,
    rutinKod: 'rtnWebKontoAnalys',
    rutinURL: 'WebKontoanalys',
    benamning: 'Web kontoanalys',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBokfJournal: {
    rutinID: 15002,
    rutinKod: 'rtnWebBokfJournal',
    rutinURL: 'WebBokforingsjournal',
    benamning: 'Web bokföringsjournal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebEKRapport: {
    rutinID: 15003,
    rutinKod: 'rtnWebEKRapport',
    rutinURL: 'WebEkonomirapporter',
    benamning: 'Web ekonomirapporter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebResultatAnalys: {
    rutinID: 15004,
    rutinKod: 'rtnWebResultatAnalys',
    rutinURL: 'Resultatkontoanalys',
    benamning: 'Resultatkontoanalys',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBalansAnalys: {
    rutinID: 15005,
    rutinKod: 'rtnWebBalansAnalys',
    rutinURL: 'Balanskontoanalys',
    benamning: 'Balanskontoanalys',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBokforder: {
    rutinID: 15006,
    rutinKod: 'rtnWebBokforder',
    rutinURL: 'Bokforingsorder',
    benamning: 'Bokföringsorder',
    leveransstatus: Leveransstatus.Active,
  },
  rtnWebAttesteraBokforder: {
    rutinID: 15007,
    rutinKod: 'rtnWebAttesteraBokforder',
    rutinURL: 'Bokforingsorder_2',
    benamning: 'Bokföringsorder',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBudgetAskandemallar: {
    rutinID: 15008,
    rutinKod: 'rtnWebBudgetAskandemallar',
    rutinURL: 'BudgetAskandemallar',
    benamning: 'Budget Äskandemallar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebKalender: {
    rutinID: 16001,
    rutinKod: 'rtnWebKalender',
    rutinURL: 'Kalender',
    benamning: 'Kalender',
    leveransstatus: Leveransstatus.Active,
  },
  rtnWebStatistikRapportering: {
    rutinID: 16002,
    rutinKod: 'rtnWebStatistikRapportering',
    rutinURL: 'WebStatistikrapportering',
    benamning: 'Web statistikrapportering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebForsamlingsStatistik: {
    rutinID: 16003,
    rutinKod: 'rtnWebForsamlingsStatistik',
    rutinURL: 'WebForsamlingsstatistik',
    benamning: 'Web församlingsstatistik',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBoknBestallning: {
    rutinID: 16004,
    rutinKod: 'rtnWebBoknBestallning',
    rutinURL: 'WebBoknBestallning',
    benamning: 'Web Bokn. beställning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebPubliceringsInstIntern: {
    rutinID: 16005,
    rutinKod: 'rtnWebPubliceringsInstIntern',
    rutinURL: 'WebPubliceraInternt',
    benamning: 'Web publicera internt',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebPubliceringsInstExtern: {
    rutinID: 16006,
    rutinKod: 'rtnWebPubliceringsInstExtern',
    rutinURL: 'WebPubliceraExternt',
    benamning: 'Web publicera externt',
    leveransstatus: Leveransstatus.Active,
  },
  rtnWebTjanstgoring: {
    rutinID: 16007,
    rutinKod: 'rtnWebTjanstgoring',
    rutinURL: 'WebTjanstgoring',
    benamning: 'Web tjänstgöring',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBokaGudstjanst: {
    rutinID: 16008,
    rutinKod: 'rtnWebBokaGudstjanst',
    rutinURL: 'WebBokaGudstjanst',
    benamning: 'Web boka Gudstjänst',
    leveransstatus: Leveransstatus.Active,
  },
  rtnWebPlanering: {
    rutinID: 16009,
    rutinKod: 'rtnWebPlanering',
    rutinURL: 'Planering',
    benamning: 'Planering',
    leveransstatus: Leveransstatus.Active,
  },
  rtnWebFakturaAttest: {
    rutinID: 17001,
    rutinKod: 'rtnWebFakturaAttest',
    rutinURL: 'Fakturaattest',
    benamning: 'Fakturaattest',
    leveransstatus: Leveransstatus.Active,
  },
  rtnWebLeverantorsfakturor: {
    rutinID: 17002,
    rutinKod: 'rtnWebLeverantorsfakturor',
    rutinURL: 'Leverantorsfakturor_2',
    benamning: 'Leverantörsfakturor',
    leveransstatus: Leveransstatus.Beta,
  },
  rtnWebFakturaAttestNyaAvenyTest: {
    rutinID: 17003,
    rutinKod: 'rtnWebFakturaAttestNyaAvenyTest',
    rutinURL: 'Fakturaattest_2',
    benamning: 'Fakturaattest',
    leveransstatus: Leveransstatus.Beta,
  },
  rtnWebTidregistrering: {
    rutinID: 18001,
    rutinKod: 'rtnWebTidregistrering',
    rutinURL: 'WebTidregistrering',
    benamning: 'Web Tidregistrering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebStampelklocka: {
    rutinID: 18002,
    rutinKod: 'rtnWebStampelklocka',
    rutinURL: 'WebStampelklocka',
    benamning: 'Web Stämpelklocka',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBisattningsjournal: {
    rutinID: 19001,
    rutinKod: 'rtnBisattningsjournal',
    rutinURL: 'Bisattningsjournal',
    benamning: 'Bisättningsjournal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBisattningstyp: {
    rutinID: 19002,
    rutinKod: 'rtnBisattningstyp',
    rutinURL: 'BisattningstyperOchUtcheckningsstatus',
    benamning: 'Bisättningstyper och utcheckningsstatus',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBisattningslokal: {
    rutinID: 19003,
    rutinKod: 'rtnBisattningslokal',
    rutinURL: 'Bisattningslokaler',
    benamning: 'Bisättningslokaler',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBisattningsUStatus: {
    rutinID: 19004,
    rutinKod: 'rtnBisattningsUStatus',
    rutinURL: 'UtcheckningsstatusForKista',
    benamning: 'Utcheckningsstatus för kista',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBisattningSettings: {
    rutinID: 19005,
    rutinKod: 'rtnBisattningSettings',
    rutinURL: 'OvrigaInstallningar',
    benamning: 'Övriga inställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBisattningsUStatusUrna: {
    rutinID: 19006,
    rutinKod: 'rtnBisattningsUStatusUrna',
    rutinURL: 'UtcheckningsstatusForUrna',
    benamning: 'Utcheckningsstatus för urna',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUsersBJ: {
    rutinID: 19007,
    rutinKod: 'rtnUsersBJ',
    rutinURL: 'AnvandareBisattningsinstallningar',
    benamning: 'Användare, bisättningsinställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnKremBestallningar: {
    rutinID: 19008,
    rutinKod: 'rtnKremBestallningar',
    rutinURL: 'Kremationsbestallningar',
    benamning: 'Kremationsbeställningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBisattningtransport: {
    rutinID: 19009,
    rutinKod: 'rtnBisattningtransport',
    rutinURL: 'Transportlista',
    benamning: 'Transportlista',
    leveransstatus: Leveransstatus.Alfa,
  },
  optKremRapportLayoutBJ: {
    rutinID: 19010,
    rutinKod: 'optKremRapportLayoutBJ',
    rutinURL: 'Kremationsblankettlayouter_2',
    benamning: 'Kremationsblankettlayouter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnUtskickLogg: {
    rutinID: 19011,
    rutinKod: 'rtnUtskickLogg',
    rutinURL: 'Utskick_2',
    benamning: 'Utskick',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBisattningskontakter: {
    rutinID: 19012,
    rutinKod: 'rtnBisattningskontakter',
    rutinURL: 'Bisattningskontakter',
    benamning: 'Bisättningskontakter',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSekretessBisattning: {
    rutinID: 19013,
    rutinKod: 'rtnSekretessBisattning',
    rutinURL: 'SekretessbehorighetBisattning',
    benamning: 'Sekretessbehörighet Bisättning',
    leveransstatus: Leveransstatus.Active,
  },
  rtnWebBisattningsjournal: {
    rutinID: 20001,
    rutinKod: 'rtnWebBisattningsjournal',
    rutinURL: 'WebLamnaInHamtaUt',
    benamning: 'Web Lämna in/Hämta ut',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBisattningsRegister: {
    rutinID: 20002,
    rutinKod: 'rtnWebBisattningsRegister',
    rutinURL: 'WebRegistrering',
    benamning: 'Web Registrering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBisattningsAktAvlidna: {
    rutinID: 20003,
    rutinKod: 'rtnWebBisattningsAktAvlidna',
    rutinURL: 'WebAktuellaAvlidna',
    benamning: 'Web Aktuella avlidna',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBisattningsBestallaKrem: {
    rutinID: 20004,
    rutinKod: 'rtnWebBisattningsBestallaKrem',
    rutinURL: 'WebBestallaKremation',
    benamning: 'Web beställa kremation',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBisattningValjLokal: {
    rutinID: 20005,
    rutinKod: 'rtnWebBisattningValjLokal',
    rutinURL: 'WebValjLokal',
    benamning: 'Web välj lokal',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebBisattningKortinlogg: {
    rutinID: 20006,
    rutinKod: 'rtnWebBisattningKortinlogg',
    rutinURL: 'WebKortinloggning',
    benamning: 'Web kortinloggning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebGrav: {
    rutinID: 21001,
    rutinKod: 'rtnWebGrav',
    rutinURL: 'Gravplatser',
    benamning: 'Gravplatser',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebGravHandelseLogg: {
    rutinID: 21002,
    rutinKod: 'rtnWebGravHandelseLogg',
    rutinURL: 'WebGravhandelser',
    benamning: 'Web gravhändelser',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebGravAnordningar: {
    rutinID: 21003,
    rutinKod: 'rtnWebGravAnordningar',
    rutinURL: 'WebGravanordningar',
    benamning: 'Web gravanordningar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebGravVanvard: {
    rutinID: 21004,
    rutinKod: 'rtnWebGravVanvard',
    rutinURL: 'WebVanvard',
    benamning: 'Web Vanvård',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebMyCarta: {
    rutinID: 21005,
    rutinKod: 'rtnWebMyCarta',
    rutinURL: 'WebMyCarta',
    benamning: 'Web myCarta',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebOrder: {
    rutinID: 22001,
    rutinKod: 'rtnWebOrder',
    rutinURL: 'Order',
    benamning: 'Order',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebKund: {
    rutinID: 22002,
    rutinKod: 'rtnWebKund',
    rutinURL: 'WebKund',
    benamning: 'Web Kund',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebArtikel: {
    rutinID: 22003,
    rutinKod: 'rtnWebArtikel',
    rutinURL: 'WebArtikel',
    benamning: 'Web Artikel',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebPostlista: {
    rutinID: 23001,
    rutinKod: 'rtnWebPostlista',
    rutinURL: 'WebPostlista',
    benamning: 'Web Postlista',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebArende: {
    rutinID: 23002,
    rutinKod: 'rtnWebArende',
    rutinURL: 'WebArenden',
    benamning: 'Web Ärenden',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebHandling: {
    rutinID: 23003,
    rutinKod: 'rtnWebHandling',
    rutinURL: 'WebHandlingar',
    benamning: 'Web Handlingar',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebInventering: {
    rutinID: 24001,
    rutinKod: 'rtnWebInventering',
    rutinURL: 'WebInventering',
    benamning: 'Web Inventering',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSecurity: {
    rutinID: 99002,
    rutinKod: 'rtnSecurity',
    rutinURL: 'Sakerhet',
    benamning: 'Säkerhet',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnSupportInfo: {
    rutinID: 99003,
    rutinKod: 'rtnSupportInfo',
    rutinURL: 'SupportInfo',
    benamning: 'Support info',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWelcomeInfo: {
    rutinID: 99004,
    rutinKod: 'rtnWelcomeInfo',
    rutinURL: 'ValkomsthalsningAnvandare',
    benamning: 'Välkomsthälsning Användare',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBestallningInfo: {
    rutinID: 99006,
    rutinKod: 'rtnBestallningInfo',
    rutinURL: 'BestallningsinfoBegravning',
    benamning: 'Beställningsinfo Begravning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWelcomeInfoBegrByra: {
    rutinID: 99007,
    rutinKod: 'rtnWelcomeInfoBegrByra',
    rutinURL: 'ValkomsthalsningBegravningsbyraer',
    benamning: 'Välkomsthälsning Begravningsbyråer',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnBestallningInfoGravs: {
    rutinID: 99008,
    rutinKod: 'rtnBestallningInfoGravs',
    rutinURL: 'BestallningsinfoGravsattning',
    benamning: 'Beställningsinfo Gravsättning',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnWebNavet: {
    rutinID: 99009,
    rutinKod: 'rtnWebNavet',
    rutinURL: 'Navet',
    benamning: 'Navet',
    leveransstatus: Leveransstatus.Alfa,
  },
  rtnGeneric: {
    rutinID: 1000000,
    rutinKod: 'rtnGeneric',
    rutinURL: 'GenerellRutin',
    benamning: 'Generell rutin',
    leveransstatus: Leveransstatus.Alfa,
  },
};

export const rutinKeys: IRutinKeys = {
  [1]: 'rtnGrav',
  [2]: 'rtnSkotselFakt',
  [3]: 'rtnGravsatta',
  [4]: 'rtnArbetsunderlagSkapa',
  [5]: 'rtnArbetsunderlag',
  [6]: 'optArbetsomraden',
  [7]: 'optKGardar',
  [8]: 'optStyrvarden',
  [9]: 'rtnGravSkotAdm',
  [10]: 'rtnKontakter',
  [11]: 'rtnKontokalkyler',
  [12]: 'rtnFasttidsavtAvr',
  [13]: 'optSkotsellistor',
  [14]: 'rtnSkotselExport',
  [15]: 'optGravlistor',
  [16]: 'rtnGamlaAvtal',
  [17]: 'rtnOrderOmg',
  [18]: 'rtnGravExtraSecurity',
  [19]: 'rtnAvrakningsavtAvr',
  [20]: 'rtnGravarBytKontakt',
  [21]: 'rtnFasttidsavtalUpprEn',
  [22]: 'rtnFasttidsavtalUppr',
  [23]: 'rtnAvrakningsavtKalk',
  [24]: 'rtnGravanalys',
  [25]: 'rtnBestallningsOrder',
  [26]: 'optMallar',
  [27]: 'rtnRensaBetansv',
  [28]: 'rtnRensaESAvtal',
  [29]: 'rtnPubliceraGravsatta',
  [30]: 'rtnSkotslar',
  [31]: 'rtnGravKartaTeman',
  [32]: 'rtnEjSkuldfAvtal',
  [33]: 'rtnSkotslar2',
  [34]: 'rtnSkotslar3',
  [35]: 'rtnGravHandelseLogg',
  [36]: 'rtnInformationskiosk',
  [37]: 'rtnGravarNollaSaldo',
  [38]: 'rtnAvtalFakt',
  [39]: 'rtnUtgaendeSkotsel',
  [40]: 'rtnExporteraPersonFraga',
  [41]: 'rtnSkotselKategorier',
  [42]: 'rtnSkotselBestallningar',
  [43]: 'rtnGravMyCartaUrval',
  [44]: 'rtnGravanordningar',
  [45]: 'rtnPubliceradeKartor',
  [46]: 'rtnSvenskaGravar',
  [47]: 'rtnSekretessGrav',
  [48]: 'optHandelseinstallningar',
  [49]: 'rtnUsersGA',
  [50]: 'rtnUtseGravrattsinnehavare',
  [51]: 'optGravrattsinnehavareInstallningar',
  [52]: 'optVanvardsarendenInstallningar',
  [53]: 'rtnVanvardsarenden',
  [1001]: 'rtnAktiviteter',
  [1002]: 'rtnKalender',
  [1003]: 'rtnResurser',
  [1004]: 'rtnBegrByraOld',
  [1005]: 'rtnGudstjansttyp',
  [1006]: 'rtnDeltagarlista',
  [1007]: 'rtnBONummerserier',
  [1008]: 'rtnAktTypInstallningar',
  [1009]: 'rtnDeltagare',
  [1010]: 'rtnResursRubriker',
  [1011]: 'rtnFakturaOmgang',
  [1012]: 'rtnOPGrupp',
  [1013]: 'rtnBegrByra',
  [1014]: 'rtnWebKalenderOld',
  [1015]: 'rtnStatistikrapportering',
  [1016]: 'rtnVerksamhetstyper',
  [1017]: 'rtnSammankomst',
  [1018]: 'rtnBegravningstyp',
  [1019]: 'rtnAktivitetskategori',
  [1020]: 'rtnAnnonseras',
  [1021]: 'rtnGruppmedlemmar',
  [1022]: 'rtnAnmalningar',
  [1023]: 'rtnBestallningar',
  [1025]: 'rtnUsersBO',
  [1026]: 'rtnResurstyper',
  [1029]: 'rtnBokningar',
  [1030]: 'rtnAktdeltagare',
  [1031]: 'rtnAktkontakt',
  [1032]: 'rtnTjanstgoring',
  [1033]: 'rtnPlaneringskategorier',
  [1034]: 'rtnResursgrupp',
  [1035]: 'rtnBoknBest',
  [1036]: 'optBoknBestSettings',
  [1037]: 'rtnArsbaseradStatistik',
  [1038]: 'rtnStatistikrapporteringNew',
  [1039]: 'rtnSekretessBokning',
  [1040]: 'optPsalmer',
  [2001]: 'rtnKonteringsmall',
  [2002]: 'optKontoplan',
  [2003]: 'rtnKontodel',
  [2004]: 'rtnVerifikation',
  [2005]: 'rtnIngBalans',
  [2006]: 'rtnBudgetVerifikation',
  [2007]: 'rtnKontoAnalys',
  [2008]: 'rtnEkonomiRapporter',
  [2009]: 'rtnAutomatkontering',
  [2010]: 'rtnSpecEkoRapport',
  [2011]: 'rtnEKRapportmall',
  [2012]: 'rtnEKLonefil',
  [2013]: 'rtnEKImporteraBudget',
  [2014]: 'rtnBudgetKurva',
  [2015]: 'rtnEKRapporthuvud',
  [2016]: 'optMomskod',
  [2017]: 'rtnUpdateIBWizard',
  [2018]: 'rtnValjKonteringsbegrepp',
  [2019]: 'rtnDetaljeringsniva',
  [2020]: 'rtnWebKontoAnalysOld',
  [2021]: 'rtnEKRapportkategori',
  [2022]: 'rtnEKRapportpaket',
  [2023]: 'rtnWebBokfJournalOld',
  [2024]: 'rtnSIEExport',
  [2025]: 'rtnKopieraBudget',
  [2026]: 'rtnKonteringar',
  [2027]: 'rtnLikviditetsplan',
  [2028]: 'rtnSIEImport',
  [2029]: 'rtnOmfordelning',
  [2030]: 'rtnGavogrupp',
  [2031]: 'rtnGava',
  [2032]: 'rtnGavorad',
  [2033]: 'rtnGavorubrik',
  [2034]: 'rtnLoneanalys',
  [2035]: 'rtnVerunderlag',
  [2036]: 'rtnUsersEK',
  [2037]: 'rtnFakturahandelser',
  [2038]: 'rtnBudgetgrupp',
  [2039]: 'rtnLonetillagg',
  [2040]: 'rtnPersonalgrupp',
  [2041]: 'rtnBefattningskod',
  [2042]: 'rtnAvtalsomrade',
  [2043]: 'rtnPersonalregister',
  [2044]: 'rtnPalagg',
  [2045]: 'rtnBudgetkategori',
  [2046]: 'rtnArbetsbudget',
  [2047]: 'rtnArbetsbudgetBudgetgrupp',
  [2048]: 'rtnArbetsbudgetPersonalregister',
  [2049]: 'rtnBudgeteringsmodell',
  [2050]: 'rtnArbetsbudgetrad',
  [2051]: 'rtnBudgetrutinInstallningar',
  [2052]: 'rtnArbetsbudgetPersonalbudgetrader',
  [2053]: 'rtnEKSettings',
  [2054]: 'rtnKodbehorigheter',
  [2055]: 'rtnBokforingsmall',
  [2056]: 'rtnBokforingsorder',
  [2057]: 'rtnEKLoneart',
  [2058]: 'rtnTillaggsinfo',
  [2059]: 'rtnEKLonefilIntern',
  [2060]: 'rtnEkonomiskAnalys',
  [2061]: 'rtnAnalysutdelning',
  [2062]: 'rtnKOBTransTyper',
  [2063]: 'rtnKOBAterredovisning',
  [2065]: 'rtnMomsunderlag',
  [2066]: 'rtnSkapaMomsunderlag',
  [2067]: 'rtnKOBKollektFil',
  [2068]: 'rtnKOBKollektstyrning',
  [2069]: 'rtnMallarForUtlandskMoms',
  [3001]: 'rtnTillgang',
  [3002]: 'rtnRubrik',
  [3003]: 'rtnByggnaderRum',
  [3004]: 'rtnAnlKat',
  [3005]: 'rtnAnlGrupp',
  [3006]: 'rtnOmrade',
  [3007]: 'rtnInvestRader',
  [3008]: 'rtnAutoAvskr',
  [3009]: 'rtnAutoInternranta',
  [3010]: 'rtnMakuleraInvrad',
  [3011]: 'rtnHuvudRubrik',
  [3012]: 'rtnVisaInvestering',
  [3013]: 'rtnNyNedskrivning',
  [3014]: 'rtnNyAvyttr',
  [3015]: 'rtnPagaendeInvestering',
  [3016]: 'rtnOmklassificering',
  [3017]: 'rtnMakuleraAvrakning',
  [3018]: 'rtnVerksamhetskod',
  [3019]: 'rtnAtgardskod',
  [3020]: 'rtnImporteraTillgangar',
  [3021]: 'rtnKomponent',
  [3022]: 'rtnByteInvesteringskonto',
  [3023]: 'rtnInventeringsansvarig',
  [3024]: 'rtnInventeringsomgang',
  [3025]: 'rtnFordelningsmall',
  [3026]: 'rtnForbruknInvRader',
  [3027]: 'rtnSKVAutoAvskr',
  [4001]: 'rtnOrder',
  [4002]: 'rtnFaktura',
  [4003]: 'rtnFakturalayout',
  [4004]: 'rtnSaljare',
  [4005]: 'rtnFaktureringsgrupp',
  [4006]: 'rtnKreditorder',
  [4007]: 'rtnFakturaUppslag',
  [4008]: 'rtnOrderkategori',
  [4009]: 'rtnPrisavtal',
  [4010]: 'rtnOrderrad',
  [4011]: 'rtnImporteraOrderunderlag',
  [4012]: 'rtnOrderunderlag',
  [4013]: 'rtnRantefakturering',
  [4014]: 'rtnRanteomgang',
  [4015]: 'rtnSkapaPeriodOrder',
  [4055]: 'rtnOrdermottagningsvag',
  [4056]: 'rtnScheduler',
  [4057]: 'rtnFlerbolagshantering',
  [4058]: 'rtnSIEMottagningsvag',
  [4059]: 'rtnUsersMall',
  [5001]: 'rtnKremationsjournal',
  [5002]: 'optKrematorie',
  [5003]: 'optBegravningsplats',
  [5004]: 'optKGardAnnanOrt',
  [5005]: 'optKremRapportLayout',
  [5006]: 'optKremlistor',
  [5007]: 'rtnAktuellaKremationer',
  [5008]: 'rtnSekretessKremation',
  [6001]: 'rtnFakturakund',
  [6002]: 'rtnKontokund',
  [6003]: 'rtnKundkategori',
  [6004]: 'rtnManuellInbetalning',
  [6005]: 'rtnBokforingsjournal',
  [6006]: 'rtnKund',
  [6007]: 'rtnAutomatiskInbetalning',
  [6008]: 'rtnKreditering',
  [6009]: 'rtnUtbetalningtillgodohavande',
  [6010]: 'rtnMakuleraHandelseKund',
  [6011]: 'rtnBeraknaTillgodoranta',
  [6012]: 'rtnKravutskrift',
  [6013]: 'rtnKrKontoAvstamning',
  [6014]: 'rtnBetalaKontofaktura',
  [6015]: 'rtnRegleraInternfakturor',
  [6016]: 'rtnMedgivande',
  [6017]: 'rtnAutogirobet',
  [6018]: 'optMallKund',
  [6019]: 'rtnKundfakturaanalys',
  [6020]: 'rtnKravomgang',
  [6021]: 'rtnKundfakturabunt',
  [6022]: 'rtnBetalningsfiler',
  [6023]: 'rtnInbetalningsvag',
  [6024]: 'rtnLicenser',
  [6025]: 'rtnUtbetalningKreditfaktura',
  [6026]: 'rtnKundfakturahandelser',
  [6027]: 'rtnAterrappAgresso',
  [6028]: 'rtnAterrappOrderDynamic',
  [7001]: 'rtnUsers',
  [7002]: 'rtnRoller',
  [7003]: 'rtnAvenyGrupper',
  [7004]: 'rtnNummerserier',
  [7005]: 'rtnRanteTabell',
  [7006]: 'rtnMoms',
  [7007]: 'rtnBokfar',
  [7008]: 'rtnBank',
  [7009]: 'rtnKravrutin',
  [7010]: 'rtnBetalningsvillkor',
  [7011]: 'rtnBetalningssatt',
  [7012]: 'rtnLeveransvillkor',
  [7013]: 'rtnValuta',
  [7014]: 'rtnLand',
  [7015]: 'rtnSprak',
  [7016]: 'rtnTitlar',
  [7017]: 'optLKF',
  [7018]: 'rtnUtbetalningssatt',
  [7019]: 'rtnUtbetalningsvag',
  [7020]: 'rtnBokningsgrupper',
  [7021]: 'rtnInavisering',
  [7022]: 'rtnSystemOrg',
  [7023]: 'rtnNummerserierUpd',
  [7024]: 'rtnRapportLayout',
  [7025]: 'rtnLogg',
  [7026]: 'rtnKonteringskod',
  [7027]: 'rtnUndo',
  [7028]: 'rtnAutogiromall',
  [7029]: 'rtnPostnr',
  [7030]: 'rtnUrval',
  [7031]: 'rtnArbetsstalle',
  [7032]: 'rtnEkostyr',
  [7033]: 'rtnFaktGruppSkotsel',
  [7034]: 'rtnKnavUpdate',
  [7035]: 'rtnBlankettStyr',
  [7036]: 'rtnVisaRapporter',
  [7037]: 'rtnVisaUrval',
  [7038]: 'rtnClearingArtiklar',
  [7039]: 'rtnFakturaformedlare',
  [7040]: 'rtnFakturakoder',
  [7041]: 'rtnFakturaradskoder',
  [7042]: 'rtnSystemSettings',
  [7043]: 'rtnBevakning',
  [7045]: 'rtnImportXML',
  [7046]: 'rtnExportXML',
  [7048]: 'rtnPublishNews',
  [7049]: 'rtnTestSKK',
  [7050]: 'rtnKOBIntegration',
  [7051]: 'rtnRensaSKK',
  [7052]: 'rtnTestXbridge',
  [7053]: 'rtnCommunicator',
  [7054]: 'rtnUDs',
  [7055]: 'rtnKommunikationsfil',
  [7056]: 'rtnUppdateraGASStandard',
  [7057]: 'rtnIgangkorningGAS',
  [7058]: 'rtnFramsidan',
  [7059]: 'rtnFormedlingsuppdrag',
  [7061]: 'rtnKonverteringar',
  [7062]: 'rtnAdressanvandning',
  [7063]: 'rtnRegisterutdrag',
  [7064]: 'rtnGDPRInventering',
  [7065]: 'rtnGDPRPersonkategorier',
  [7066]: 'rtnNyckeltal',
  [7067]: 'rtnProcesser',
  [7068]: 'rtnStatistikinstallningar',
  [7069]: 'rtnJobb',
  [7070]: 'rtnIntegrationMedFlex',
  [7071]: 'rtnPersonlogg',
  [7072]: 'rtnJobbA',
  [7073]: 'rtnIgangkorningEjGAS',
  [7074]: 'rtnSYSOptions',
  [7075]: 'rtnDigitalaSigneringar',
  [7076]: 'rtnGASOut',
  [7902]: 'rtnTest1',
  [7903]: 'rtnTest2',
  [7904]: 'rtnTest3',
  [7905]: 'rtnTest4',
  [7906]: 'rtnTest5',
  [7907]: 'rtnTest6',
  [7908]: 'rtnTest7',
  [7909]: 'rtnTest8',
  [7910]: 'rtnTest9',
  [7911]: 'rtnTest10',
  [7921]: 'rtnDemo1',
  [8001]: 'rtnOrganisationer',
  [8002]: 'rtnPersoner',
  [8003]: 'rtnLokaler',
  [8004]: 'rtnOrgPersLok',
  [8005]: 'rtnOPLInternalRoutine',
  [8006]: 'rtnOPLFind',
  [8007]: 'rtnAdresser_HarUtgatt',
  [8008]: 'rtnForsamlingar',
  [8009]: 'rtnAdressbokKontakter',
  [8010]: 'rtnTvist',
  [8011]: 'rtnAvliden',
  [9001]: 'rtnArtiklar',
  [9002]: 'rtnEnhet',
  [9003]: 'rtnArtikelgrupp',
  [9004]: 'rtnPrislista',
  [9005]: 'rtnFakturatext',
  [10001]: 'rtnLevkategori',
  [10002]: 'rtnLeverantorer',
  [10003]: 'rtnAttestanter',
  [10004]: 'rtnAnkomstregistrering',
  [10005]: 'rtnDefinitivbokning',
  [10006]: 'rtnUtbetalningsuppdrag',
  [10007]: 'rtnBokfutbet',
  [10008]: 'rtnMakuleraHandelseLeverantor',
  [10009]: 'rtnJusteraLevfakturabelopp',
  [10010]: 'rtnKontoAvstamning',
  [10011]: 'rtnLRKvartalsStatistik',
  [10012]: 'rtnAnkregAvstamning',
  [10013]: 'rtnFakturabunt',
  [10014]: 'rtnFakturabevakning',
  [10015]: 'rtnAttestGrupp',
  [10016]: 'rtnAttestOmrade',
  [10017]: 'rtnFakturamottagningsvag',
  [10018]: 'rtnAttestforslag',
  [10019]: 'rtnLevFakturor',
  [10020]: 'rtnBetalRedov',
  [10021]: 'rtnLeverantorBetSatt',
  [10022]: 'rtnVisaLeverantorsAttester',
  [11001]: 'rtnMusikstycke',
  [11002]: 'rtnForfattare',
  [11003]: 'rtnForkortningar',
  [11004]: 'rtnMusikgrupper',
  [11005]: 'rtnUpdateMBAS',
  [11006]: 'rtnNotarkiv',
  [11007]: 'rtnFramforanden',
  [11008]: 'rtnNoter',
  [11009]: 'rtnForlag',
  [12001]: 'rtnDatabaslogg',
  [12002]: 'rtnProgramAndring',
  [12003]: 'rtnRutinVal',
  [12004]: 'rtnCreateUpdate',
  [12005]: 'rtnAndringsLogg',
  [12006]: 'optVerOptions',
  [12007]: 'rtnReportFields',
  [12008]: 'rtnWebSurvey',
  [12009]: 'rtnFAQ',
  [12010]: 'rtnUppdatering',
  [13001]: 'rtnDiarie',
  [13002]: 'optDiarieplan',
  [13003]: 'rtnPostlista',
  [13004]: 'rtnDiariePlan',
  [13005]: 'rtnHandlaggare',
  [13006]: 'rtnMottagare',
  [13007]: 'rtnHandlingstyp',
  [13008]: 'rtnDokument',
  [13009]: 'rtnDiariegrupp',
  [13010]: 'rtnDIStandardText',
  [13011]: 'rtnDIStandardTextArkiv',
  [13012]: 'rtnDIListor',
  [13013]: 'rtnVisaDiarie',
  [13014]: 'rtnVisaPostlista',
  [13015]: 'rtnUsersDI',
  [14001]: 'rtnFaktureringstyp',
  [14002]: 'rtnTIEnhet',
  [14003]: 'rtnTIInstallningar',
  [14004]: 'rtnTidredovisningsparametrar',
  [14005]: 'rtnVeckoschema',
  [14006]: 'rtnRapporteringskod',
  [14007]: 'rtnAnstalld',
  [14008]: 'rtnTidregistrering',
  [14009]: 'rtnArbetsuppgifter',
  [14010]: 'rtnTidGrupp',
  [14011]: 'rtnTIProjekt',
  [14012]: 'rtnPrioritet',
  [14013]: 'rtnTidrapporteringar',
  [14014]: 'rtnManadsAvslut',
  [14015]: 'rtnLoneartKategori',
  [14016]: 'rtnAnstalldKategori',
  [14017]: 'rtnInloggningsStatus',
  [14018]: 'rtnStampelklocka',
  [14019]: 'rtnRapporteringskod2',
  [14020]: 'rtnDagschema',
  [14021]: 'rtnTidbank',
  [14022]: 'rtnBokforTidrapporteringar',
  [14023]: 'rtnVarningstyper',
  [14024]: 'rtnVarningslista',
  [14025]: 'rtnAnstalldBegr',
  [14026]: 'rtnFordelaTid',
  [14027]: 'rtnPeriodregistrering',
  [14028]: 'rtnTaBortTidrapportering',
  [14029]: 'rtnRegistreraForDemo',
  [14030]: 'rtnTIRapport',
  [14031]: 'rtnSpecTIRapport',
  [14032]: 'rtnTIRapportkategori',
  [14033]: 'rtnTIRapporthuvud',
  [14034]: 'rtnTIAttest',
  [14035]: 'rtnTIAttestkategorier',
  [14036]: 'rtnTIAttestomraden',
  [14037]: 'rtnLoneunderlag',
  [14038]: 'rtnLonearter',
  [14039]: 'rtnRapporteringsobjekt',
  [14040]: 'rtnTidrapporteringBegr',
  [14041]: 'rtnPeriodregistreringBegr',
  [14042]: 'rtnFordelaTidBegr',
  [14043]: 'rtnPafyllSemDagar',
  [14044]: 'rtnDagrapporteringar',
  [14045]: 'rtnSchemaOB',
  [14046]: 'rtnOBRegistrering',
  [14047]: 'rtnStampel',
  [15001]: 'rtnWebKontoAnalys',
  [15002]: 'rtnWebBokfJournal',
  [15003]: 'rtnWebEKRapport',
  [15004]: 'rtnWebResultatAnalys',
  [15005]: 'rtnWebBalansAnalys',
  [15006]: 'rtnWebBokforder',
  [15007]: 'rtnWebAttesteraBokforder',
  [15008]: 'rtnWebBudgetAskandemallar',
  [16001]: 'rtnWebKalender',
  [16002]: 'rtnWebStatistikRapportering',
  [16003]: 'rtnWebForsamlingsStatistik',
  [16004]: 'rtnWebBoknBestallning',
  [16005]: 'rtnWebPubliceringsInstIntern',
  [16006]: 'rtnWebPubliceringsInstExtern',
  [16007]: 'rtnWebTjanstgoring',
  [16008]: 'rtnWebBokaGudstjanst',
  [16009]: 'rtnWebPlanering',
  [17001]: 'rtnWebFakturaAttest',
  [17002]: 'rtnWebLeverantorsfakturor',
  [17003]: 'rtnWebFakturaAttestNyaAvenyTest',
  [18001]: 'rtnWebTidregistrering',
  [18002]: 'rtnWebStampelklocka',
  [19001]: 'rtnBisattningsjournal',
  [19002]: 'rtnBisattningstyp',
  [19003]: 'rtnBisattningslokal',
  [19004]: 'rtnBisattningsUStatus',
  [19005]: 'rtnBisattningSettings',
  [19006]: 'rtnBisattningsUStatusUrna',
  [19007]: 'rtnUsersBJ',
  [19008]: 'rtnKremBestallningar',
  [19009]: 'rtnBisattningtransport',
  [19010]: 'optKremRapportLayoutBJ',
  [19011]: 'rtnUtskickLogg',
  [19012]: 'rtnBisattningskontakter',
  [19013]: 'rtnSekretessBisattning',
  [20001]: 'rtnWebBisattningsjournal',
  [20002]: 'rtnWebBisattningsRegister',
  [20003]: 'rtnWebBisattningsAktAvlidna',
  [20004]: 'rtnWebBisattningsBestallaKrem',
  [20005]: 'rtnWebBisattningValjLokal',
  [20006]: 'rtnWebBisattningKortinlogg',
  [21001]: 'rtnWebGrav',
  [21002]: 'rtnWebGravHandelseLogg',
  [21003]: 'rtnWebGravAnordningar',
  [21004]: 'rtnWebGravVanvard',
  [21005]: 'rtnWebMyCarta',
  [22001]: 'rtnWebOrder',
  [22002]: 'rtnWebKund',
  [22003]: 'rtnWebArtikel',
  [23001]: 'rtnWebPostlista',
  [23002]: 'rtnWebArende',
  [23003]: 'rtnWebHandling',
  [24001]: 'rtnWebInventering',
  [99002]: 'rtnSecurity',
  [99003]: 'rtnSupportInfo',
  [99004]: 'rtnWelcomeInfo',
  [99006]: 'rtnBestallningInfo',
  [99007]: 'rtnWelcomeInfoBegrByra',
  [99008]: 'rtnBestallningInfoGravs',
  [99009]: 'rtnWebNavet',
  [1000000]: 'rtnGeneric',
};
